var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftwareDevWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 919.69 784.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7b7b7;\n      }\n\n      .cls-2 {\n        fill: #b4c9d9;\n      }\n\n      .cls-3 {\n        fill: #90a0ad;\n      }\n\n      .cls-4 {\n        fill: #8e890d;\n      }\n\n      .cls-5 {\n        fill: #9c960f;\n      }\n\n      .cls-6 {\n        fill: #343434;\n      }\n\n      .cls-7 {\n        fill: #abd9ce;\n      }\n\n      .cls-8 {\n        fill: #222326;\n      }\n\n      .cls-9 {\n        fill: #8796a3;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-11 {\n        fill: #3a2528;\n      }\n\n      .cls-12 {\n        fill: #b4ad11;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-14 {\n        fill: #974fa8;\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-16 {\n        fill: #f4f4f4;\n      }\n\n      .cls-17, .cls-18, .cls-19 {\n        fill: #fff;\n      }\n\n      .cls-20 {\n        fill: #82b3b8;\n      }\n\n      .cls-21 {\n        fill: #584245;\n      }\n\n      .cls-22 {\n        fill: #22252b;\n      }\n\n      .cls-23 {\n        fill: #858e94;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-25 {\n        fill: #96b2db;\n      }\n\n      .cls-26 {\n        fill: #d1d1d1;\n      }\n\n      .cls-27 {\n        fill: #848484;\n      }\n\n      .cls-28 {\n        fill: #e3f1fe;\n      }\n\n      .cls-29 {\n        fill: #a5a5a5;\n      }\n\n      .cls-30 {\n        fill: #7c418a;\n      }\n\n      .cls-31 {\n        fill: #316a77;\n      }\n\n      .cls-32 {\n        fill: #22ecfa;\n      }\n\n      .cls-33 {\n        fill: #80438f;\n      }\n\n      .cls-34 {\n        fill: #262930;\n      }\n\n      .cls-35 {\n        fill: #d8d8d8;\n      }\n\n      .cls-36 {\n        fill: #894899;\n      }\n\n      .cls-37 {\n        fill: #28488f;\n      }\n\n      .cls-38 {\n        fill: #752289;\n      }\n\n      .cls-39 {\n        opacity: .5;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-41 {\n        fill: #0c0c0c;\n      }\n\n      .cls-42 {\n        fill: #722285;\n      }\n\n      .cls-43 {\n        fill: #62494d;\n      }\n\n      .cls-44 {\n        fill: #98920e;\n      }\n\n      .cls-45 {\n        fill: #e2e2e2;\n      }\n\n      .cls-46 {\n        fill: #355fbd;\n      }\n\n      .cls-47 {\n        fill: #c3dff4;\n      }\n\n      .cls-48 {\n        fill: #cde4f7;\n      }\n\n      .cls-49 {\n        fill: #e3b1e5;\n      }\n\n      .cls-50 {\n        fill: #daebf9;\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-52 {\n        fill: #9c52ad;\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-54 {\n        isolation: isolate;\n      }\n\n      .cls-55 {\n        fill: #d3e7f8;\n      }\n\n      .cls-18 {\n        opacity: .3;\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-57 {\n        fill: #1dad93;\n      }\n\n      .cls-58 {\n        fill: #d6d6d6;\n      }\n\n      .cls-59 {\n        fill: #3a67cc;\n      }\n\n      .cls-60 {\n        fill: #b760cc;\n      }\n\n      .cls-19, .cls-61 {\n        opacity: .1;\n      }\n\n      .cls-62 {\n        fill: #d7eaf9;\n      }\n\n      .cls-63 {\n        fill: #325ab3;\n      }\n\n      .cls-64 {\n        fill: #8e4a9e;\n      }\n\n      .cls-65 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-66 {\n        fill: #c9c9c9;\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-68 {\n        fill: #272a30;\n      }\n\n      .cls-69 {\n        fill: #c1d6e8;\n      }\n\n      .cls-70 {\n        fill: #73808a;\n      }\n\n      .cls-71 {\n        fill: #27468a;\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-73 {\n        fill: #85800c;\n      }\n\n      .cls-74 {\n        fill: #7b8388;\n      }\n\n      .cls-75 {\n        fill: #773e85;\n      }\n\n      .cls-76 {\n        fill: #b9cdde;\n      }\n\n      .cls-77 {\n        fill: #4c1659;\n      }\n\n      .cls-78 {\n        fill: #3865c7;\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-81 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-82 {\n        fill: #c9dff2;\n      }\n\n      .cls-83 {\n        fill: #899298;\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-87 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-88 {\n        fill: #6c207f;\n      }\n\n      .cls-89 {\n        fill: #223a7a;\n      }\n\n      .cls-90 {\n        fill: #969696;\n      }\n\n      .cls-91 {\n        fill: #a19b0f;\n      }\n\n      .cls-92 {\n        fill: #b35ec7;\n      }\n\n      .cls-93 {\n        fill: #8b9ba8;\n      }\n\n      .cls-94 {\n        opacity: .4;\n      }\n\n      .cls-95 {\n        fill: #d9eaf9;\n      }\n\n      .cls-96 {\n        fill: #938d0e;\n      }\n\n      .cls-97 {\n        fill: #94a4b2;\n      }\n\n      .cls-98 {\n        fill: #bdd2e3;\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-100 {\n        fill: #336e7c;\n      }\n\n      .cls-101 {\n        fill: #6f7b85;\n      }\n\n      .cls-102 {\n        fill: #77848f;\n      }\n\n      .cls-103 {\n        fill: #8e8e8e;\n      }\n\n      .cls-104 {\n        fill: #d5e9f8;\n      }\n\n      .cls-105 {\n        fill: #afa910;\n      }\n\n      .cls-106 {\n        fill: #898989;\n      }\n\n      .cls-107 {\n        fill: #beb612;\n      }\n\n      .cls-108 {\n        fill: #2f6673;\n      }\n\n      .cls-109 {\n        fill: #eaeaea;\n      }\n\n      .cls-110 {\n        fill: #7f8d99;\n      }\n\n      .cls-111 {\n        fill: #5b1b6a;\n      }\n\n      .cls-112 {\n        fill: #2d509e;\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-114 {\n        fill: #316976;\n      }\n\n      .cls-115 {\n        fill: #ff66a8;\n      }\n\n      .cls-116 {\n        fill: #147866;\n      }\n\n      .cls-117 {\n        fill: #521860;\n      }\n\n      .cls-118 {\n        fill: #ae5bc2;\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-120 {\n        fill: #a3a3a3;\n      }\n\n      .cls-121 {\n        fill: #2a4b94;\n      }\n\n      .cls-122 {\n        fill: #ffaa83;\n      }\n\n      .cls-123 {\n        fill: #357280;\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-125 {\n        fill: #6b7780;\n      }\n\n      .cls-126 {\n        fill: #c3cfdb;\n      }\n\n      .cls-127 {\n        fill: #151516;\n      }\n\n      .cls-128 {\n        fill: #e5e5e5;\n      }\n\n      .cls-129 {\n        fill: #854694;\n      }\n\n      .cls-130 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-131 {\n        fill: #81898f;\n      }\n\n      .cls-132 {\n        fill: #878787;\n      }\n\n      .cls-133 {\n        fill: #21c1a5;\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-135 {\n        fill: #afafaf;\n      }\n\n      .cls-136 {\n        fill: #d3d3d3;\n      }\n\n      .cls-137 {\n        fill: #9eb0bf;\n      }\n\n      .cls-138 {\n        fill: #601c71;\n      }\n\n      .cls-139 {\n        fill: #367584;\n      }\n\n      .cls-140 {\n        fill: #b1c4d5;\n      }\n\n      .cls-141 {\n        fill: #2c2e33;\n      }\n\n      .cls-142 {\n        fill: none;\n      }\n\n      .cls-143 {\n        fill: #5d1c6d;\n      }\n\n      .cls-144 {\n        fill: #551963;\n      }\n\n      .cls-145 {\n        fill: #f79f7c;\n      }\n\n      .cls-146 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-148 {\n        fill: #c1c1c1;\n      }\n\n      .cls-149 {\n        fill: #999;\n      }\n\n      .cls-150 {\n        fill: #bcbcbc;\n      }\n\n      .cls-151 {\n        fill: #e8e8e8;\n      }\n\n      .cls-152 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-153 {\n        fill: #9b9b9b;\n      }\n\n      .cls-154 {\n        fill: #2d2d2d;\n      }\n\n      .cls-155 {\n        fill: #b9b211;\n      }\n\n      .cls-156 {\n        fill: #807b0c;\n      }\n\n      .cls-157 {\n        fill: #9cadbc;\n      }\n\n      .cls-158 {\n        fill: #476f99;\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-160 {\n        fill: #efefef;\n      }\n\n      .cls-161 {\n        fill: #83929e;\n      }\n\n      .cls-162 {\n        fill: #c5dbed;\n      }\n\n      .cls-163 {\n        fill: #631d74;\n      }\n\n      .cls-164 {\n        fill: #a6a00f;\n      }\n\n      .cls-165 {\n        fill: #98a9b7;\n      }\n\n      .cls-166 {\n        fill: #24272b;\n      }\n\n      .cls-167 {\n        fill: #70a6c5;\n      }\n\n      .cls-168 {\n        fill: #a556b8;\n      }\n\n      .cls-169 {\n        fill: #89840d;\n      }\n\n      .cls-170 {\n        fill: #a054b3;\n      }\n\n      .cls-171 {\n        fill: #a4b6c6;\n      }\n\n      .cls-172 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-174 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-175 {\n        fill: #a0b2c1;\n      }\n\n      .cls-176 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-177 {\n        fill: #92c8ce;\n      }\n\n      .cls-178 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-179 {\n        fill: #7b770b;\n      }\n\n      .cls-180 {\n        fill: #cecece;\n      }\n\n      .cls-181 {\n        fill: #787f85;\n      }\n\n      .cls-182 {\n        fill: #b5b5b5;\n      }\n\n      .cls-183 {\n        fill: #7f7f7f;\n      }\n\n      .cls-184 {\n        fill: #3158ad;\n      }\n\n      .cls-185 {\n        fill: #b0c4d4;\n      }\n\n      .cls-186 {\n        fill: #aba410;\n      }\n\n      .cls-187 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-188 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-189 {\n        fill: #9e9e9e;\n      }\n\n      .cls-190 {\n        fill: #4f175c;\n      }\n\n      .cls-191 {\n        fill: #acc0cf;\n      }\n\n      .cls-192 {\n        fill: #2e53a3;\n      }\n\n      .cls-193 {\n        fill: #1e1e1e;\n      }\n\n      .cls-194 {\n        fill: #a8bbcb;\n      }\n\n      .cls-195 {\n        fill: #a959bd;\n      }\n\n      .cls-196 {\n        fill: #7b8994;\n      }\n\n      .cls-197 {\n        fill: #661e78;\n      }\n\n      .cls-198 {\n        fill: #345db8;\n      }\n\n      .cls-199 {\n        fill: #f2f2f2;\n      }\n\n      .cls-200 {\n        fill: #ffb420;\n      }\n\n      .cls-201 {\n        fill: #c4c4c4;\n      }\n\n      .cls-202 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-203 {\n        fill: #581a67;\n      }\n\n      .cls-204 {\n        fill: #7c848a;\n      }\n\n      .cls-205 {\n        fill: #dcc9a0;\n      }\n\n      .cls-206 {\n        fill: #3055a8;\n      }\n\n      .cls-207 {\n        fill: #6f2182;\n      }\n\n      .cls-208 {\n        fill: #934da3;\n      }\n\n      .cls-209 {\n        fill: #254385;\n      }\n\n      .cls-210 {\n        fill: #2b4d99;\n      }\n\n      .cls-211 {\n        fill: #3762c2;\n      }\n\n      .cls-212 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-213 {\n        fill: #131414;\n      }\n\n      .cls-214 {\n        fill: #bcc1c4;\n      }\n\n      .cls-215 {\n        fill: #691f7b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M315.47,532.28c-1.71-.96-3.41-1.94-5.11-2.91-1.5-.85-2.99-1.69-4.47-2.54-1.07-.62-2.13-1.21-3.2-1.82-2.31-1.32-3.77-4.14-3.81-8.18l12.78,7.27c.04,4.03,1.49,6.85,3.81,8.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M349.26,255.13c1.26,.72,3,.6,4.92-.52l12.76,7.27c-1.91,1.13-3.66,1.24-4.9,.52-3.84-2.18-8.94-5.08-12.78-7.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M360.89,242.7c-.01-2.16-.81-3.69-2.05-4.41l12.78,7.27c1.23,.71,2.02,2.23,2.04,4.4,.05,4.34-2.95,9.69-6.72,11.9l-12.76-7.27c3.78-2.22,6.77-7.56,6.72-11.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M358.84,238.3l12.78,7.27c-1.25-.71-2.98-.6-4.88,.51l-12.77-7.27c1.89-1.1,3.62-1.23,4.87-.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M362.03,262.39c-3.4-1.94-6.8-3.87-10.21-5.81-.63-.37-1.28-.74-1.91-1.09-.19-.12-.45-.26-.65-.37-1.22-.7-2.01-2.23-2.03-4.37-.06-4.36,2.98-9.71,6.75-11.94l12.77,7.27c-3.78,2.23-6.81,7.58-6.76,11.95,.03,2.14,.8,3.66,2.04,4.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M343.41,253.01c-.03-2.17-.81-3.7-2.06-4.41l12.77,7.27c1.24,.71,2.04,2.23,2.05,4.41,.05,4.33-2.95,9.67-6.73,11.9l-12.75-7.27c3.76-2.23,6.77-7.56,6.73-11.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M341.35,248.61l12.77,7.27c-1.26-.73-2.97-.6-4.87,.51l-12.77-7.27c1.89-1.11,3.61-1.23,4.86-.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M344.53,272.7l-12.76-7.27c-1.24-.7-2.01-2.21-2.04-4.35-.07-4.38,2.97-9.73,6.75-11.95l12.77,7.27c-3.78,2.23-6.8,7.58-6.76,11.95,.04,2.14,.81,3.66,2.04,4.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M314.27,275.75c1.27,.71,3.02,.6,4.9-.53l12.77,7.27c-1.9,1.12-3.64,1.24-4.9,.52-3.83-2.18-8.94-5.09-12.77-7.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M325.91,263.32c-.03-2.17-.8-3.7-2.05-4.42l12.79,7.27c1.22,.72,2.01,2.24,2.05,4.42,.04,4.33-2.95,9.67-6.75,11.9l-12.77-7.27c3.79-2.23,6.77-7.56,6.74-11.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M323.86,258.9l12.79,7.27c-1.26-.72-2.99-.59-4.87,.53l-12.78-7.28c1.89-1.1,3.6-1.23,4.86-.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M327.04,283.01l-12.77-7.26c-1.23-.71-2-2.23-2.03-4.38-.05-4.36,2.98-9.72,6.76-11.95l12.78,7.28c-3.8,2.22-6.81,7.57-6.77,11.93,.03,2.15,.81,3.66,2.04,4.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.71,68.72l-6.91-4.02c-1.23-.73-2.01-2.26-2.01-4.45l6.89,4.01c.02,2.2,.8,3.73,2.04,4.46Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M474.97,.47l6.9,4.02c-1.26-.73-3.02-.63-4.94,.48l-6.91-4.02c1.93-1.11,3.69-1.21,4.95-.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.59,32.79l-6.91-4.02c0-4.42,3.11-9.79,6.92-12l6.92,4.02c-3.83,2.2-6.94,7.57-6.93,11.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M333.71,390.39l-13.32-7.74c.02,5.1-3.56,11.3-7.99,13.86l13.3,7.74c4.44-2.56,8.02-8.77,8.01-13.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M331.37,380.6l-13.32-7.74c1.43,.84,2.32,2.62,2.34,5.16l13.31,7.73c0-2.52-.91-4.31-2.33-5.15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M331.37,380.6l-13.32-7.74c-1.47-.84-3.48-.72-5.72,.57l13.32,7.74c2.22-1.31,4.25-1.42,5.73-.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M730.66,322.17c-1.69-.99-3.4-1.97-5.09-2.97-.77-.43-1.8-.37-2.96,.29l5.1,2.96c1.16-.66,2.2-.72,2.95-.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M660.89,372.04c.24,.15,.59,.12,.96-.1l2.53,1.43c-.39,.22-.73,.24-.99,.1-.76-.43-1.75-1-2.51-1.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M663.18,369.59c0-.43-.17-.73-.42-.87l2.53,1.44c.24,.14,.4,.44,.4,.87,.01,.86-.59,1.91-1.32,2.35l-2.53-1.43c.74-.44,1.34-1.5,1.33-2.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M659.72,371.63c0-.43-.17-.73-.41-.87l2.53,1.44c.24,.14,.4,.44,.4,.87,.01,.85-.58,1.92-1.33,2.36l-2.52-1.44c.74-.44,1.34-1.5,1.33-2.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M659.31,370.76l2.53,1.44c-.25-.15-.59-.12-.95,.1l-2.54-1.44c.38-.22,.71-.24,.96-.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M659.94,375.52l-2.52-1.44c-.25-.14-.39-.44-.4-.86-.02-.87,.59-1.93,1.32-2.37l2.54,1.44c-.76,.44-1.35,1.5-1.35,2.36,0,.43,.15,.73,.4,.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M653.96,376.13c.26,.14,.59,.12,.97-.11l2.53,1.44c-.38,.22-.73,.25-.98,.1-.76-.43-1.76-1.01-2.52-1.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M656.26,373.67c0-.44-.16-.74-.41-.88l2.54,1.43c.24,.15,.4,.45,.4,.88,0,.85-.58,1.92-1.32,2.36l-2.53-1.44c.75-.44,1.34-1.5,1.34-2.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M779.7,612.55l.02,9.04c.01,4.57,3.03,9.15,9.03,12.64,12.09,7.03,31.78,7.03,43.95,0,6.13-3.54,9.19-8.18,9.17-12.81,0-3.02-.01-6.03-.02-9.05,0,4.64-3.05,9.28-9.17,12.82-12.17,7.02-31.85,7.02-43.94,0-6.02-3.49-9.02-8.07-9.03-12.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M435.11,500.25c3.01-1.74,4.27-6.32,2.81-10.18l2.36-.16c1.47,3.85,.23,8.45-2.79,10.18-.72,.05-1.67,.11-2.38,.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M426.92,472.32l2.37-.15c2.42-.17,4.84,1.53,5.98,4.52l-2.36,.18c-1.15-3.01-3.56-4.72-5.99-4.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M428.53,467.33l2.37-.16c-.71,.05-1.45,.26-2.14,.66l-2.36,.16c.7-.4,1.44-.62,2.13-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M426.92,472.32l2.37-.15c-.74,.03-1.45,.26-2.16,.66l-2.37,.15c.69-.37,1.42-.6,2.16-.66Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M412.52,513.28s.1,0,.14-.02c.44-.02,.91-.04,1.35-.08,.29,0,.61-.02,.9-.06-.73,.4-1.46,.64-2.17,.66l-2.37,.15c.72-.03,1.46-.25,2.15-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M412.75,513.79l-2.37,.15c-2.44,.17-4.84-1.54-6-4.52l2.39-.15c1.12,2.97,3.53,4.7,5.98,4.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M401.76,496.06l-2.4,.16c-1.46-3.88-.21-8.43,2.81-10.19l2.36-.15c-3.01,1.74-4.26,6.28-2.77,10.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M518.78,454.86l-9.71-5.65c-1.75-1.02-2.84-3.18-2.87-6.24l9.72,5.64c0,3.07,1.11,5.24,2.86,6.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M561.3,358.94l9.72,5.64c-1.78-1.03-4.23-.88-6.94,.68l-9.73-5.64c2.71-1.56,5.18-1.71,6.96-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M515.81,404.36l-9.72-5.64c-.01-6.23,4.37-13.77,9.73-16.86l9.73,5.64c-5.38,3.11-9.76,10.66-9.74,16.87Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M889.56,423.51c-22.51-34.42-57.66-66.64-105.54-94.23-110.39-63.83-262.53-88.37-405.02-74.03-89.95,9.05-176.11,33.76-245.43,74.03C53.36,375.84,9.43,435.43,1.35,496.38c-9.93,75.1,34.8,152.18,134.31,209.64,151.08,87.22,380.1,101.34,555.69,42.25,33.94-11.35,65.88-25.42,94.82-42.25,131.42-76.29,165.69-187.61,103.39-282.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M750.75,235.25c0-5.94-4.23-8.28-9.34-5.34l-36.76,21.25c-5.1,2.94-9.3,10.15-9.28,16.07v3.69s-1.5,.9-1.5,.9l1.51,2.21,.02,9.99-1.63,4.26,1.67,.94,.04,20.2c.03,5.92,4.24,8.28,9.35,5.31l36.75-21.21c5.13-2.96,9.3-10.15,9.3-16.08l-.13-42.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M743.46,229.03c.52-.17,1.03-.29,1.52-.33,.04,0,.1,0,.14-.01,.54-.06,1.05-.02,1.51,.06,.03,0,.04,.01,.05,.02,.51,.11,.97,.28,1.37,.52l-9.27-5.37s-.03-.04-.05-.06c-.17-.07-.3-.15-.49-.21-.14-.09-.32-.13-.48-.19-.12-.02-.21-.06-.34-.07-.03,0-.04,0-.05,0-.07-.02-.09-.03-.13-.04-.18-.02-.37-.07-.57-.07-.2,0-.4,0-.61,0-.08,0-.14,0-.2,.03-.05,0-.1,0-.14,.02-.11,0-.23,0-.36,.02-.25,.05-.52,.1-.81,.18-.13,.03-.24,.08-.36,.13-.13,.02-.22,.06-.32,.09-.15,.06-.29,.09-.43,.15-.41,.18-.85,.41-1.28,.65l-36.77,21.21c-1.08,.62-2.14,1.45-3.11,2.4-.15,.15-.27,.31-.42,.46-.05,.05-.1,.12-.17,.17-.14,.15-.28,.3-.42,.46-.25,.29-.52,.61-.75,.92-.22,.27-.43,.57-.61,.86-.2,.25-.39,.53-.55,.81-.17,.26-.34,.5-.49,.78-.02,.02-.02,.07-.03,.08h-.01c-.14,.24-.27,.47-.39,.72-.16,.25-.27,.5-.4,.78-.12,.26-.24,.53-.39,.82-.11,.27-.22,.56-.31,.83-.13,.3-.22,.59-.31,.88-.06,.15-.1,.31-.17,.48,0,.04-.01,.06-.01,.11-.04,.12-.09,.26-.12,.37-.11,.36-.18,.73-.27,1.07-.08,.42-.16,.87-.21,1.28-.1,.64-.14,1.23-.14,1.84l.14,42.16c0,2.94,1.06,5.01,2.71,6l9.27,5.37c-1.67-.96-2.72-3.01-2.72-5.97l-.11-42.2c0-1.48,.24-3.02,.73-4.58,0,0,0-.04,0-.07,.47-1.53,1.13-3.07,1.97-4.49,0,0,0-.02,0-.03,.82-1.42,1.81-2.73,2.89-3.88,.04-.05,.1-.12,.15-.19,1.08-1.13,2.28-2.13,3.52-2.83l36.76-21.25c.59-.31,1.16-.57,1.72-.77,.1-.05,.23-.09,.33-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M725.06,261.84c1.51,.47,2.51,2.1,2.51,4.68,.02,2.59-.74,5.26-2.1,7.54-1.76,2.95-4.41,5.34-7.51,7.12-.68,.41-1.31,.73-1.78,.91l.03,9.48-5.18,2.99-.06-26.18c1.59-1.21,3.85-2.75,7.04-4.58,3.22-1.88,5.52-2.49,7.04-1.95Zm-7.14,14.76c2.79-1.63,4.48-4.2,4.47-6.91,0-2.46-1.49-3.05-4.08-1.55-1.07,.64-1.79,1.16-2.16,1.49l.02,7.82c.44-.13,.99-.42,1.75-.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M736.27,260.28c1.97-1.13,3.72-1.6,4.75-1.6l-.94,4.64c-.74-.05-2.19,.16-3.62,1-1.25,.72-1.97,1.72-1.97,2.71,0,.92,.64,1.02,2.7,.64,3.2-.59,4.55,.5,4.58,3.31,0,3.61-2.46,7.66-7.24,10.43-2.24,1.27-4.15,1.83-5.44,1.79l.9-4.85c.97,.13,2.98-.23,4.52-1.13,1.55-.9,2.21-1.91,2.21-2.9s-.52-1.15-2.48-.78c-3.45,.66-4.8-.72-4.78-3.04,0-3.58,2.67-7.84,6.79-10.24Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.07 474.38 307.04 541.61 632.22 353.88 520.38 288.88 199.07 474.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M313.52,51.94l-8.26,21.34,8.82,12.3-7.73,4.46-2.67-4.62c-1.1-1.71-1.83-3.07-2.65-4.56l-.1,.05c-.57,2.31-1.33,4.52-2.24,7.39l-2.44,7.57-7.64,4.4,8.49-22.1-8.26-11.98,7.65-4.42,2.61,4.7c.87,1.54,1.53,2.82,2.25,4.33,.79-2.61,1.35-4.43,2.09-6.84l2.48-7.63,7.58-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M348.74,31.61l1.73,32.94-6.54,3.77-.47-12.73c-.13-4.01-.29-8.83-.29-13.78l-.13,.07c-.9,4.87-2.15,10.38-3.26,15.03l-3.56,15.3-5.19,2.99-3.19-11.31c-.96-3.41-2.01-7.66-2.7-11.68l-.1,.06c-.16,4.66-.27,9.98-.5,14.34l-.47,13.18-6.19,3.57,1.78-34.98,8.91-5.14,2.93,9.65c.91,3.36,1.86,7.05,2.52,10.67l.13-.07c.82-4.41,1.81-9.48,2.76-13.81l3.12-13.07,8.71-5.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "363.09 23.32 363.17 50.76 374.88 43.99 374.92 50.45 356.49 61.08 356.39 27.19 363.09 23.32"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "275.56 168.16 275.95 303.13 204.58 344.34 204.19 209.37 275.56 168.16"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "409.71 134.92 409.85 183.54 296.94 248.73 296.79 200.12 409.71 134.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M189.87,201.86L419.61,69.22l.47,163.29-229.74,132.65-.47-163.3Zm86.08,101.27l-.38-134.97-71.38,41.21,.4,134.97,71.36-41.21h0Zm133.9-119.58l-.14-48.62-112.92,65.2,.15,48.61,112.91-65.19h0Zm-.17-61.34l-.11-31.41-112.89,65.19,.07,31.4,112.93-65.19h0Zm.28,103.55l-.09-30.36-112.92,65.18,.11,30.37,112.9-65.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "409.87 195.39 409.96 225.75 297.06 290.94 296.95 260.57 409.87 195.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "409.57 90.79 409.68 122.2 296.75 187.38 296.68 155.98 409.57 90.79"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "419.57 53.01 419.61 69.22 189.87 201.86 189.83 185.66 419.57 53.01"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "325 193.45 325.45 354.21 240.45 403.29 239.97 242.53 325 193.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "484.76 153.88 484.91 211.79 350.45 289.43 350.27 231.52 484.76 153.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M222.92,233.6L496.57,75.61l.55,194.5L223.47,428.09l-.55-194.5Zm102.53,120.61l-.45-160.76-85.03,49.08,.47,160.76,85.01-49.08h0Zm159.46-142.42l-.15-57.91-134.49,77.65,.18,57.9,134.46-77.64h0Zm-.19-73.07l-.12-37.41-134.48,77.65,.1,37.4,134.5-77.64h0Zm.35,123.33l-.09-36.16-134.51,77.64,.12,36.17,134.48-77.65h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "484.98 225.89 485.07 262.05 350.59 339.7 350.47 303.53 484.98 225.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "484.6 101.31 484.72 138.72 350.22 216.36 350.12 178.96 484.6 101.31"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "496.51 56.31 496.57 75.61 222.92 233.6 222.88 214.3 496.51 56.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M532.61,56.39c3.45-2,6.08-2.72,7.27-2.69l-1.35,6.88c-1.36,.1-3.23,.61-5.59,1.98-5.3,3.05-9.42,9.1-9.41,16.66,.03,6.79,3.54,9.02,9.5,5.59,2.04-1.17,4.26-2.95,5.55-4.3l1.02,5.38c-1.2,1.42-3.97,3.77-7.54,5.83-10.22,5.9-15.5,1.65-15.52-8.01-.03-11.59,7.14-22.16,16.07-27.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M555.21,43.34c3.31-1.91,5.78-2.55,7.53-2.65l-1.47,7.04c-1.18,.05-3.28,.28-6.18,1.95-2.89,1.67-4.29,3.99-4.29,5.77,.02,2.15,1.69,2.13,5.49,1.59,5.21-.77,7.68,.95,7.69,5.7,0,5.7-3.77,12.73-11.88,17.41-3.37,1.94-6.72,2.86-8.36,2.74l1.34-7.12c1.8,.01,4.56-.52,7.38-2.15,3.1-1.79,4.69-4.15,4.69-6.38,0-2.12-1.41-2.51-4.97-1.93-4.9,.86-8.09-.39-8.11-5.34-.02-5.77,4.18-12.61,11.14-16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M579.71,29.19c3.36-1.93,5.78-2.55,7.56-2.67l-1.5,7.06c-1.19,.04-3.29,.28-6.17,1.94-2.89,1.67-4.28,3.97-4.27,5.75,.01,2.15,1.65,2.14,5.48,1.61,5.22-.79,7.66,.94,7.67,5.69,.02,5.7-3.76,12.72-11.86,17.4-3.38,1.95-6.7,2.85-8.38,2.76l1.36-7.14c1.78,.03,4.54-.5,7.39-2.15,3.07-1.76,4.69-4.15,4.69-6.37-.02-2.11-1.43-2.51-4.97-1.93-4.89,.86-8.09-.4-8.1-5.34-.04-5.77,4.14-12.59,11.09-16.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M182.93,258.62c1.9,.63,3.17,2.71,3.18,6.03,0,3.32-.95,6.7-2.67,9.62-2.27,3.76-5.65,6.81-9.59,9.09-.89,.51-1.67,.92-2.27,1.16l.04,12.11-6.64,3.84-.1-33.44c2.06-1.61,4.96-3.58,9.03-5.93,4.11-2.37,7.03-3.15,9.01-2.48Zm-9.12,18.88c3.54-2.05,5.7-5.34,5.69-8.81,0-3.13-1.88-3.9-5.2-1.98-1.38,.79-2.29,1.48-2.76,1.89l.03,10c.57-.17,1.25-.53,2.24-1.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "215.57 237.31 215.68 271.21 209 275.06 208.95 260.91 197.98 267.24 198.03 281.39 191.33 285.26 191.23 251.37 197.93 247.5 197.96 260.52 208.93 254.19 208.9 241.17 215.57 237.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M240.31,225.49c1.88,.66,3.17,2.71,3.18,6.03,0,3.32-.95,6.71-2.7,9.65-2.27,3.77-5.64,6.81-9.56,9.07-.88,.51-1.68,.92-2.29,1.17l.03,12.12-6.6,3.81-.1-33.43c2.07-1.62,4.96-3.59,9.04-5.94,4.11-2.37,7.02-3.15,9.01-2.48Zm-9.17,18.9c3.55-2.05,5.74-5.36,5.73-8.84,0-3.12-1.91-3.88-5.23-1.96-1.34,.77-2.26,1.46-2.76,1.9l.03,10c.6-.19,1.28-.55,2.23-1.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M315.47,532.28c-1.71-.96-3.41-1.94-5.11-2.91-1.5-.85-2.99-1.69-4.47-2.54-1.07-.62-2.13-1.21-3.2-1.82-2.31-1.32-3.77-4.14-3.81-8.18l12.78,7.27c.04,4.03,1.49,6.85,3.81,8.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M315.47,532.28l-12.77-7.27c-2.31-1.32-3.77-4.14-3.81-8.18l12.78,7.27c.04,4.03,1.49,6.85,3.81,8.17h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M362.03,262.39l-12.78-7.26s.04,.01,.05,.01l12.75,7.28s-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M362.06,262.42l-12.75-7.28c.1,.07,.23,.13,.34,.18l12.77,7.27c-.12-.04-.25-.11-.36-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M362.42,262.58l-12.77-7.27c.12,.05,.25,.08,.37,.12l12.77,7.26c-.13-.03-.26-.07-.37-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M362.79,262.7l-12.77-7.26c.12,.03,.25,.07,.39,.08l12.77,7.28c-.14-.03-.28-.07-.39-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M363.18,262.8l-12.77-7.28c.14,.03,.28,.04,.41,.04l12.77,7.27c-.15,0-.28-.02-.4-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M363.58,262.84l-12.77-7.27c.16,0,.3,.01,.46,0l12.77,7.27c-.17,0-.32,0-.47,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M364.05,262.84l-12.77-7.27c.17,0,.35-.03,.51-.06l12.78,7.27c-.18,.03-.35,.05-.52,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M364.57,262.78l-12.78-7.27c.2-.04,.39-.07,.61-.14l12.77,7.27c-.22,.05-.41,.1-.6,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M365.17,262.65l-12.77-7.27c.26-.07,.53-.16,.8-.29l12.79,7.27c-.29,.11-.57,.21-.82,.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M365.99,262.36l-12.79-7.27c.32-.14,.63-.29,.97-.48l12.76,7.27c-.32,.19-.66,.35-.95,.49h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "309.14 309.62 296.39 302.34 615.03 114.58 627.79 121.84 309.14 309.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M366.94,261.87l-12.76-7.27c.8-.47,1.57-1.08,2.26-1.79l12.77,7.26c-.7,.71-1.46,1.32-2.27,1.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M369.2,260.08l-12.77-7.26c.25-.26,.51-.53,.74-.81l12.78,7.27c-.23,.29-.48,.55-.74,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M369.95,259.28l-12.78-7.27c.19-.22,.38-.45,.56-.68l12.77,7.26c-.18,.25-.37,.47-.55,.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M370.5,258.59l-12.77-7.26c.14-.22,.3-.42,.45-.63l12.77,7.27c-.15,.22-.28,.42-.45,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M370.95,257.97l-12.77-7.27c.14-.19,.27-.39,.38-.59l12.78,7.26c-.12,.21-.25,.41-.39,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M371.34,257.37l-12.78-7.26c.14-.2,.25-.39,.38-.59l12.75,7.27c-.1,.18-.22,.38-.35,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M371.69,256.8l-12.75-7.27c.08-.2,.19-.39,.31-.59l12.75,7.27c-.1,.19-.2,.39-.31,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M372,256.21l-12.75-7.27c.09-.19,.18-.39,.27-.59l12.78,7.27c-.09,.2-.2,.39-.3,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M372.3,255.63l-12.78-7.27c.11-.2,.2-.4,.29-.59l12.77,7.27c-.1,.19-.18,.4-.28,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M372.57,255.03l-12.77-7.27c.09-.2,.16-.42,.24-.62l12.77,7.26c-.07,.22-.15,.42-.24,.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M372.81,254.4l-12.77-7.26c.09-.22,.17-.43,.23-.64l12.77,7.27c-.08,.21-.15,.42-.22,.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M373.04,253.76l-12.77-7.27c.08-.24,.14-.47,.22-.71l12.77,7.26c-.07,.24-.15,.48-.22,.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M373.26,253.05l-12.77-7.26c.04-.26,.13-.53,.17-.79l12.77,7.27c-.07,.26-.12,.53-.17,.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M373.43,252.27l-12.77-7.27c.06-.31,.11-.63,.15-.95l12.77,7.27c-.02,.32-.11,.63-.15,.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M373.58,251.31l-12.77-7.27c.08-.45,.09-.9,.08-1.34-.01-2.16-.81-3.69-2.05-4.41l12.78,7.27c1.23,.71,2.02,2.23,2.04,4.4,0,.44-.02,.89-.08,1.34h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M366.75,246.09l-12.77-7.27c.33-.19,.64-.34,.97-.48l12.75,7.27c-.31,.13-.63,.29-.95,.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M367.7,245.6l-12.75-7.27c.26-.13,.53-.21,.79-.29l12.79,7.27c-.27,.07-.56,.17-.83,.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M368.52,245.32l-12.79-7.27c.2-.05,.4-.1,.62-.14l12.75,7.27c-.18,.04-.4,.09-.58,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M369.1,245.18l-12.75-7.27c.16-.02,.32-.04,.51-.05l12.75,7.27c-.15,0-.32,.03-.5,.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M369.6,245.12l-12.75-7.27c.14,0,.29,0,.44,0l12.77,7.27c-.14,0-.3,0-.46,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M370.07,245.13l-12.77-7.27c.15,0,.27,.03,.43,.04l12.76,7.27c-.14-.02-.28-.03-.41-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M370.48,245.17l-12.76-7.27c.12,.02,.25,.04,.38,.08l12.76,7.27c-.13-.04-.25-.07-.38-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M370.86,245.26l-12.76-7.27c.11,.04,.23,.08,.35,.13l12.76,7.27c-.11-.04-.22-.09-.36-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M371.22,245.38l-12.76-7.27c.13,.04,.25,.1,.35,.16l12.78,7.27c-.11-.05-.24-.12-.37-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M371.58,245.55l-12.78-7.27s.03,.01,.04,.02l12.78,7.27s-.03-.02-.04-.03h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M362.03,262.39l-12.78-7.26c-1.22-.7-2.01-2.23-2.03-4.37,0-.44,.02-.89,.06-1.35l12.78,7.27c-.04,.46-.07,.91-.07,1.35,.03,2.14,.8,3.66,2.04,4.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M360.07,256.68l-12.78-7.27c.06-.31,.09-.64,.17-.95l12.76,7.26c-.07,.33-.12,.65-.16,.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M360.22,255.72l-12.76-7.26c.06-.27,.11-.54,.19-.8l12.76,7.27c-.05,.26-.13,.53-.18,.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M360.4,254.94l-12.76-7.27c.06-.22,.14-.47,.21-.7l12.77,7.28c-.09,.22-.15,.45-.22,.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M360.62,254.24l-12.77-7.28c.08-.21,.14-.43,.24-.66l12.77,7.28c-.1,.22-.16,.43-.24,.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M360.86,253.59l-12.77-7.28c.07-.2,.15-.41,.23-.62l12.77,7.27c-.08,.2-.17,.41-.23,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M361.09,252.97l-12.77-7.27c.1-.19,.17-.4,.27-.6l12.77,7.27c-.08,.2-.19,.41-.28,.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M361.37,252.35l-12.77-7.27c.09-.2,.18-.39,.29-.57l12.76,7.26c-.11,.19-.18,.38-.29,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M361.65,251.78l-12.76-7.26c.09-.22,.21-.41,.32-.59l12.77,7.26c-.11,.19-.22,.4-.33,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M361.98,251.18l-12.77-7.26c.1-.2,.22-.39,.34-.59l12.76,7.27c-.13,.2-.26,.4-.34,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M362.32,250.6l-12.76-7.27c.13-.2,.26-.39,.37-.59l12.79,7.27c-.13,.19-.27,.4-.4,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M362.71,250.01l-12.79-7.27c.17-.21,.32-.42,.48-.62l12.76,7.26c-.14,.21-.31,.42-.46,.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M363.17,249.38l-12.76-7.26c.15-.25,.35-.47,.54-.69l12.78,7.26c-.19,.24-.38,.47-.55,.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M363.72,248.68l-12.78-7.26c.25-.28,.5-.56,.75-.81l12.76,7.27c-.25,.25-.5,.53-.73,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M364.46,247.88l-12.76-7.27c.72-.71,1.48-1.32,2.28-1.79l12.77,7.27c-.79,.47-1.56,1.08-2.29,1.79h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M349.44,272.18l-12.75-7.27c.79-.48,1.56-1.08,2.26-1.79l12.76,7.26c-.69,.71-1.46,1.32-2.27,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M351.7,270.39l-12.76-7.26c.24-.26,.51-.53,.73-.82l12.78,7.28c-.23,.28-.49,.54-.74,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M352.45,269.59l-12.78-7.28c.21-.22,.37-.44,.57-.67l12.78,7.27c-.2,.24-.37,.46-.57,.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M353.02,268.9l-12.78-7.27c.15-.21,.29-.42,.44-.62l12.77,7.27c-.14,.22-.28,.42-.43,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M353.45,268.28l-12.77-7.27c.14-.19,.27-.4,.39-.6l12.78,7.27c-.12,.2-.25,.4-.4,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M353.85,267.68l-12.78-7.27c.12-.2,.24-.38,.36-.58l12.78,7.27c-.13,.21-.24,.39-.37,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M354.21,267.1l-12.78-7.27c.1-.2,.22-.39,.32-.59l12.76,7.27c-.1,.2-.2,.39-.29,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M354.51,266.52l-12.76-7.27c.09-.19,.19-.39,.29-.59l12.77,7.27c-.09,.2-.2,.4-.3,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M354.81,265.93l-12.77-7.27c.11-.19,.18-.4,.27-.6l12.77,7.28c-.08,.19-.18,.4-.26,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M355.07,265.34l-12.77-7.28c.09-.19,.16-.41,.25-.62l12.78,7.28c-.1,.2-.18,.41-.26,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M355.33,264.72l-12.78-7.28c.06-.22,.15-.43,.22-.65l12.76,7.28c-.05,.21-.14,.42-.2,.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M355.54,264.08l-12.76-7.28c.07-.24,.15-.47,.22-.7l12.77,7.28c-.08,.22-.13,.46-.22,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M355.76,263.37l-12.77-7.28c.06-.26,.13-.52,.19-.78l12.76,7.26c-.04,.27-.13,.52-.18,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M355.94,262.57l-12.76-7.26c.05-.32,.11-.64,.15-.95l12.76,7.26c-.05,.31-.11,.64-.16,.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M356.1,261.62l-12.76-7.26c.05-.46,.08-.91,.07-1.35-.03-2.17-.81-3.7-2.06-4.41l12.77,7.27c1.24,.71,2.04,2.23,2.05,4.41,0,.44,0,.88-.07,1.34h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M349.26,256.39l-12.77-7.27c.32-.2,.65-.36,.96-.49l12.76,7.27c-.32,.14-.63,.3-.95,.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M350.21,255.9l-12.76-7.27c.28-.11,.53-.21,.8-.29l12.77,7.28c-.25,.06-.53,.16-.8,.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M351.01,255.63l-12.77-7.28c.21-.04,.41-.09,.61-.13l12.77,7.28c-.2,.02-.4,.07-.61,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M351.62,255.5l-12.77-7.28c.17-.02,.34-.04,.5-.04l12.77,7.26c-.18,0-.34,.03-.5,.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M352.12,255.43l-12.77-7.26c.15-.01,.3,0,.45,0l12.78,7.27c-.14,0-.31-.01-.46,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M352.58,255.44l-12.78-7.27c.15,0,.29,.02,.43,.04l12.77,7.27c-.15-.03-.27-.04-.42-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M353,255.48l-12.77-7.27c.13,.03,.25,.05,.4,.09l12.74,7.27c-.1-.04-.24-.06-.37-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M353.37,255.56l-12.74-7.27c.1,.04,.23,.07,.35,.12l12.76,7.27c-.11-.05-.24-.09-.36-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M353.73,255.69l-12.76-7.27c.11,.06,.22,.11,.33,.18l12.79,7.26c-.12-.05-.24-.12-.36-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M354.09,255.85l-12.79-7.26s.03,0,.04,.02l12.77,7.27s-.02-.02-.03-.04h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M344.53,272.7l-12.76-7.27c-1.24-.7-2.01-2.21-2.04-4.35,0-.45,.02-.9,.09-1.35l12.74,7.26c-.04,.45-.07,.92-.07,1.35,.04,2.14,.81,3.66,2.04,4.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M342.57,266.98l-12.74-7.26c.03-.31,.05-.63,.13-.96l12.78,7.27c-.07,.32-.12,.64-.17,.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M342.74,266.04l-12.78-7.27c.07-.25,.12-.52,.19-.79l12.76,7.27c-.06,.27-.11,.53-.17,.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M342.91,265.25l-12.76-7.27c.06-.23,.12-.47,.21-.7l12.77,7.27c-.08,.24-.14,.47-.22,.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M343.13,264.54l-12.77-7.27c.07-.22,.15-.43,.23-.66l12.77,7.28c-.11,.22-.16,.44-.24,.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M343.37,263.89l-12.77-7.28c.07-.2,.15-.4,.25-.61l12.75,7.27c-.08,.2-.16,.4-.22,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M343.59,263.27l-12.75-7.27c.07-.2,.17-.4,.26-.61l12.76,7.28c-.08,.2-.18,.4-.28,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M343.87,262.67l-12.76-7.28c.09-.19,.19-.39,.29-.58l12.75,7.27c-.1,.19-.18,.37-.29,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M344.15,262.09l-12.75-7.27c.1-.2,.2-.4,.3-.59l12.79,7.27c-.12,.2-.24,.4-.33,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M344.49,261.49l-12.79-7.27c.11-.18,.24-.39,.36-.57l12.77,7.26c-.12,.19-.23,.39-.34,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M344.83,260.91l-12.77-7.26c.13-.2,.25-.41,.4-.6l12.77,7.27c-.13,.19-.26,.38-.4,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M345.22,260.32l-12.77-7.27c.15-.22,.29-.43,.46-.63l12.76,7.27c-.15,.21-.3,.42-.45,.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M345.68,259.69l-12.76-7.27c.17-.24,.35-.47,.54-.7l12.77,7.29c-.18,.21-.36,.44-.55,.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M346.22,259.01l-12.77-7.29c.25-.28,.5-.55,.76-.8l12.76,7.27c-.25,.26-.49,.53-.75,.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M346.97,258.19l-12.76-7.27c.71-.71,1.47-1.32,2.28-1.79l12.77,7.27c-.8,.48-1.57,1.09-2.28,1.8h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M327.04,283.01l-12.77-7.26s.03,0,.06,.01l12.75,7.27s-.02-.02-.04-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M327.08,283.04l-12.75-7.27c.09,.06,.22,.12,.34,.17l12.76,7.26c-.12-.04-.22-.09-.35-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M327.43,283.19l-12.76-7.26c.11,.04,.24,.09,.36,.12l12.78,7.27c-.14-.05-.26-.08-.38-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M327.81,283.33l-12.78-7.27c.12,.04,.26,.07,.38,.09l12.79,7.27c-.13-.03-.27-.05-.39-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M328.2,283.41l-12.79-7.27c.14,.01,.28,.04,.41,.05l12.79,7.26c-.14-.01-.28-.02-.41-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M328.61,283.45l-12.79-7.26c.14,0,.31,0,.47,0l12.78,7.27c-.18,0-.31,0-.46,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M329.07,283.46l-12.78-7.27c.17-.02,.34-.03,.52-.06l12.76,7.27c-.18,.03-.35,.04-.51,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M329.58,283.4l-12.76-7.27c.2-.04,.39-.07,.61-.14l12.75,7.28c-.19,.05-.4,.09-.6,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M330.18,283.27l-12.75-7.28c.25-.07,.51-.17,.8-.28l12.77,7.27c-.27,.11-.55,.21-.82,.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M330.99,282.98l-12.77-7.27c.29-.14,.63-.3,.95-.49l12.77,7.27c-.32,.2-.64,.37-.95,.49h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M331.94,282.49l-12.77-7.27c.81-.48,1.58-1.09,2.29-1.8l12.76,7.27c-.72,.72-1.48,1.32-2.28,1.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M334.22,280.7l-12.76-7.27c.25-.25,.49-.53,.74-.8l12.77,7.27c-.24,.28-.48,.55-.74,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M334.96,279.89l-12.77-7.27c.2-.22,.37-.44,.55-.69l12.77,7.27c-.2,.25-.37,.46-.55,.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M335.52,279.2l-12.77-7.27c.14-.21,.31-.4,.44-.62l12.77,7.28c-.14,.22-.28,.42-.43,.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M335.95,278.59l-12.77-7.28c.15-.19,.28-.39,.41-.6l12.75,7.28c-.11,.2-.25,.4-.4,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M336.34,278l-12.75-7.28c.13-.18,.22-.39,.34-.58l12.78,7.27c-.13,.2-.25,.39-.37,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M336.72,277.41l-12.78-7.27c.11-.2,.22-.39,.31-.59l12.78,7.28c-.1,.18-.22,.39-.31,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M337.02,276.83l-12.78-7.28c.11-.18,.21-.38,.3-.59l12.77,7.27c-.1,.2-.18,.4-.29,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M337.32,276.24l-12.77-7.27c.1-.21,.18-.39,.25-.59l12.79,7.27c-.09,.2-.17,.39-.26,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M337.58,275.65l-12.79-7.27c.1-.2,.18-.42,.26-.62l12.76,7.27c-.07,.2-.16,.4-.24,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M337.82,275.03l-12.76-7.27c.08-.21,.15-.43,.24-.65l12.76,7.27c-.09,.21-.15,.44-.24,.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M338.06,274.38l-12.76-7.27c.06-.23,.12-.47,.19-.7l12.77,7.26c-.06,.24-.14,.47-.2,.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M338.26,273.66l-12.77-7.26c.07-.26,.14-.52,.19-.78l12.77,7.26c-.06,.26-.12,.53-.19,.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M338.45,272.88l-12.77-7.26c.06-.32,.11-.65,.15-.95l12.76,7.26c-.04,.32-.1,.64-.15,.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M338.6,271.93l-12.76-7.26c.07-.47,.07-.91,.07-1.35-.03-2.17-.8-3.7-2.05-4.42l12.79,7.27c1.22,.72,2.01,2.24,2.05,4.42,0,.43-.04,.88-.09,1.33h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M331.77,266.71l-12.78-7.28c.32-.18,.64-.34,.96-.49l12.77,7.28c-.31,.13-.64,.29-.95,.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M332.72,266.22l-12.77-7.28c.28-.11,.54-.2,.8-.28l12.76,7.27c-.27,.08-.53,.17-.79,.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M333.51,265.93l-12.76-7.27c.2-.05,.4-.1,.58-.12l12.79,7.27c-.2,.02-.4,.07-.62,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M334.13,265.8l-12.79-7.27c.18-.04,.36-.06,.52-.06l12.76,7.27c-.15,0-.31,.03-.49,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M334.62,265.75l-12.76-7.27c.15,0,.3,0,.45,0l12.78,7.26c-.14,0-.3,0-.47,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M335.09,265.74l-12.78-7.26c.15,0,.29,0,.42,.05l12.78,7.26c-.14-.02-.28-.04-.42-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M335.51,265.79l-12.78-7.26c.13,0,.26,.05,.38,.07l12.79,7.27c-.14-.04-.27-.06-.39-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.89,265.87l-12.79-7.27c.12,.03,.26,.07,.37,.12l12.78,7.27c-.12-.04-.25-.09-.36-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M336.25,266l-12.78-7.27c.12,.05,.25,.1,.34,.17l12.77,7.27c-.1-.06-.22-.12-.33-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M336.58,266.16l-12.77-7.27s.03,0,.04,0l12.79,7.27s-.04,0-.06-.02h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M327.04,283.01l-12.77-7.26c-1.23-.71-2-2.23-2.03-4.38,0-.44,.02-.9,.08-1.34l12.77,7.26c-.07,.46-.09,.91-.08,1.35,.03,2.15,.81,3.66,2.04,4.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M325.09,277.3l-12.77-7.26c.04-.33,.08-.64,.14-.95l12.79,7.26c-.08,.31-.12,.64-.16,.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M325.25,276.35l-12.79-7.26c.07-.26,.12-.54,.2-.8l12.76,7.28c-.07,.26-.12,.52-.18,.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M325.42,275.56l-12.76-7.28c.06-.23,.13-.46,.21-.7l12.76,7.27c-.07,.24-.14,.47-.21,.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.63,274.85l-12.76-7.27c.07-.22,.15-.44,.22-.65l12.79,7.27c-.09,.22-.18,.44-.25,.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M325.87,274.2l-12.79-7.27c.09-.21,.17-.43,.27-.62l12.77,7.26c-.1,.21-.19,.41-.25,.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M326.12,273.57l-12.77-7.26c.07-.21,.17-.4,.24-.61l12.79,7.28c-.09,.2-.19,.4-.26,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.38,272.98l-12.79-7.28c.12-.19,.2-.38,.31-.58l12.77,7.26c-.12,.19-.22,.39-.29,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M326.68,272.38l-12.77-7.26c.1-.19,.2-.39,.32-.58l12.76,7.26c-.1,.19-.22,.39-.31,.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M326.99,271.8l-12.76-7.26c.11-.19,.22-.4,.35-.59l12.75,7.27c-.11,.2-.24,.39-.34,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M327.33,271.22l-12.75-7.27c.12-.2,.26-.4,.39-.6l12.75,7.27c-.14,.2-.26,.4-.39,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M327.72,270.62l-12.75-7.27c.15-.21,.29-.42,.45-.63l12.78,7.28c-.15,.21-.32,.41-.47,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M328.19,269.99l-12.78-7.28c.18-.23,.37-.44,.55-.68l12.77,7.27c-.18,.22-.38,.44-.54,.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M328.73,269.31l-12.77-7.27c.25-.28,.5-.55,.75-.81l12.78,7.27c-.26,.25-.51,.52-.75,.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M329.49,268.5l-12.78-7.27c.72-.71,1.49-1.32,2.29-1.8l12.78,7.28c-.8,.47-1.59,1.08-2.29,1.79h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M614.58,86.36c7.03-4.14,12.79-.9,12.88,7.21l.33,28.27-318.65,187.78-.31-28.27c-.12-8.12,5.52-18.07,12.52-22.2L614.58,86.36Zm-247.64,175.51c3.78-2.21,6.78-7.56,6.72-11.9-.05-4.35-3.14-6.11-6.91-3.88-3.78,2.23-6.81,7.58-6.76,11.95,.05,4.34,3.18,6.07,6.94,3.84h0Zm-17.5,10.31c3.79-2.23,6.79-7.57,6.73-11.9-.05-4.37-3.14-6.12-6.91-3.89-3.78,2.23-6.8,7.58-6.76,11.95,.07,4.33,3.17,6.07,6.94,3.85h0Zm-17.5,10.3c3.8-2.23,6.79-7.56,6.75-11.9-.06-4.38-3.15-6.12-6.91-3.88-3.8,2.22-6.81,7.57-6.77,11.93,.06,4.34,3.17,6.07,6.94,3.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M366.75,246.09c3.78-2.23,6.86-.47,6.91,3.88,.05,4.34-2.95,9.69-6.72,11.9-3.77,2.23-6.91,.5-6.95-3.84-.06-4.36,2.97-9.72,6.76-11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M349.26,256.39c3.77-2.23,6.86-.48,6.91,3.89,.05,4.33-2.95,9.67-6.73,11.9-3.77,2.22-6.88,.48-6.94-3.85-.04-4.36,2.99-9.72,6.76-11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M331.77,266.71c3.77-2.24,6.86-.49,6.91,3.88,.04,4.33-2.95,9.67-6.75,11.9-3.77,2.23-6.88,.49-6.94-3.85-.04-4.36,2.97-9.72,6.77-11.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "311.66 524.11 298.89 516.84 296.04 274.08 308.82 281.35 311.66 524.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M308.82,281.35l.31,28.27L627.79,121.84l2.51,214.5c.11,8.11-5.51,18.04-12.53,22.19l-293.24,172.79c-7.01,4.13-12.77,.9-12.87-7.21l-2.84-242.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M617.39,85.09c.73-.24,1.42-.4,2.08-.47,.06,0,.11-.02,.17-.02,.72-.07,1.4-.04,2.05,.08,.04,0,.07,.03,.13,.04,.66,.13,1.28,.34,1.83,.66-.03-.01-.05-.03-.08-.04l-1.99-1.13c-.16-.1-.32-.18-.48-.28-.84-.48-1.7-.97-2.56-1.45l-7.72-4.41c-.2-.11-.43-.22-.64-.3-.22-.1-.44-.18-.67-.23-.15-.05-.31-.07-.48-.11-.02,0-.05-.01-.07-.02-.05,0-.12-.03-.15-.04-.26-.04-.52-.07-.77-.08-.27,0-.56,0-.84,0-.11,0-.21,.01-.3,.03-.04,0-.1,.02-.16,.02-.15,0-.33,.03-.5,.05-.36,.06-.74,.15-1.13,.26-.15,.04-.3,.12-.48,.17-.14,.04-.3,.11-.45,.17-.2,.07-.37,.11-.56,.2-.58,.24-1.18,.54-1.77,.9L308.58,251.87c-.81,.49-1.61,1.06-2.38,1.69-.26,.21-.51,.45-.76,.69-.36,.31-.73,.62-1.1,.97-.16,.16-.31,.35-.47,.51-.12,.15-.28,.3-.41,.46-.17,.17-.32,.33-.49,.52-.34,.4-.68,.84-1.02,1.27-.13,.17-.24,.34-.37,.51-.04,.07-.09,.13-.13,.17-.12,.16-.25,.33-.34,.49-.26,.35-.51,.73-.73,1.1-.24,.36-.46,.72-.65,1.09-.04,.04-.07,.07-.08,.1-.02,.03-.03,.06-.04,.08-.18,.3-.33,.6-.49,.91-.19,.36-.37,.72-.54,1.1-.18,.32-.32,.66-.45,1-.02,.01-.02,.04-.03,.06-.01,.01-.02,.03-.03,.05-.15,.37-.31,.77-.46,1.15-.15,.4-.29,.81-.41,1.21-.08,.21-.14,.42-.18,.63-.04,.08-.05,.16-.09,.24-.04,.15-.08,.29-.13,.45-.13,.49-.25,.98-.35,1.47-.06,.29-.07,.58-.14,.88-.03,.15-.05,.31-.07,.46-.03,.14-.07,.29-.08,.43-.1,.85-.15,1.69-.14,2.51l.35,28.26,12.75,7.28-.31-28.27c-.03-.96,.05-1.94,.19-2.93,.03-.16,.04-.32,.08-.48,.14-.91,.33-1.84,.62-2.78,.03-.09,.05-.19,.09-.28,.29-1.03,.65-2.03,1.08-3.02,0,0,0-.03,0-.04,.44-1.01,.91-1.99,1.46-2.95,.04-.07,.07-.13,.1-.19,.51-.94,1.12-1.82,1.72-2.7,.08-.1,.16-.19,.22-.29,.57-.77,1.16-1.5,1.77-2.18,.17-.18,.35-.37,.51-.55,.47-.51,.98-.96,1.48-1.41,.28-.25,.54-.51,.82-.73,.78-.64,1.55-1.21,2.36-1.68L614.58,86.36c.79-.46,1.58-.8,2.32-1.1,.17-.05,.34-.11,.49-.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "400.23 310.51 400.26 317.81 378.47 341.39 378.47 341.55 400.32 339.94 400.34 347.24 371.44 348.51 371.43 342.55 400.23 310.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M422.55,299.84c2.4-1.38,5.06-2.45,7-2.73l-1.41,8.6c-1.1,.11-2.71,.58-5.15,1.98-4.78,2.76-7.92,8.46-7.81,13.96,.02,6.21,3.62,7.39,8.04,4.84,2.15-1.24,3.87-2.65,5.23-4.06l1.1,7.1c-1.62,1.76-4.7,4.2-8.17,6.21-9.47,5.47-15.57,2.35-15.59-8.27-.04-9.84,5.85-21.33,16.76-27.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M447.86,285.24c9.01-5.2,15.03-1.57,15.07,8.58,.03,12.33-7.6,22.43-15.42,26.96-8.62,4.97-15.27,2.27-15.3-8.61-.03-10.93,6.21-21.49,15.65-26.93Zm-.15,27.85c3.57-2.05,5.81-7.4,5.8-13.51-.02-5.03-1.71-9.14-5.86-6.75-4.37,2.53-5.99,8.59-5.98,13.56,.03,5.81,2.12,8.96,6.04,6.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M497.29,281.14c0,3.84,.12,7.77,.26,9.97l-8.13,4.68-.42-4.74-.13,.08c-1.83,4.85-5.39,8.88-9.17,11.06-6.95,4.01-12.57,.4-12.6-10.12-.11-11.34,6.1-21.47,13.13-25.53,3.62-2.08,6.41-2.25,7.76-.69l.04-18.34,9.15-5.28,.11,38.91Zm-9.16,.31v-4.4c0-.57-.07-1.27-.11-1.81-.55-2.54-2.56-3.72-5.39-2.08-4.14,2.4-6.31,7.95-6.28,13.23,.01,5.76,2.51,7.89,6.29,5.71,2.62-1.51,4.73-4.81,5.26-8.07,.18-.89,.22-1.64,.22-2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M530.86,254.19c0,1.76-.18,3.47-.25,4.3l-18.94,10.93c.29,4.2,4.03,4.11,8.31,1.64,3.12-1.79,5.65-3.78,8.12-6.09l1.2,6.42c-2.99,3.12-6.68,5.93-10.64,8.22-9.97,5.75-15.72,2.43-15.74-8.14-.04-8.55,4.58-20.66,14.82-26.57,9.47-5.46,13.11,.95,13.13,9.29Zm-19.31,8.08l10.83-6.24c0-2.55-.97-6.29-5.16-3.88-3.87,2.24-5.4,7.12-5.67,10.12h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "552.51 212.01 539.75 269.49 533.72 272.99 546.41 215.52 552.51 212.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "556.01 220.57 584.91 219.09 584.93 225.46 556.12 257.3 556.1 250 578.39 226.13 578.39 225.97 556.03 227.88 556.01 220.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.71,68.72l-6.91-4.02c-1.23-.73-2.01-2.26-2.01-4.45l6.89,4.01c.02,2.2,.8,3.73,2.04,4.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.71,68.72l-6.91-4.02c-1.23-.73-2.01-2.26-2.01-4.45l6.89,4.01c.02,2.2,.8,3.73,2.04,4.46h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.9,8.94c0-4.42-3.14-6.17-6.97-3.97l-27.41,15.83c-3.83,2.2-6.94,7.57-6.93,11.99v2.77s-1.12,.65-1.12,.65l1.13,1.64,.03,7.47-1.22,3.17,1.23,.72,.04,15.06c.02,4.42,3.16,6.18,6.99,3.97l27.42-15.83c3.81-2.2,6.94-7.57,6.93-12l-.11-31.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M474.97,.47l6.9,4.02c-1.26-.73-3.02-.63-4.94,.48l-6.91-4.02c1.93-1.11,3.69-1.21,4.95-.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M476.93,4.96l-6.91-4.02c.33-.19,.66-.36,.98-.48l6.89,4.02c-.3,.13-.63,.29-.96,.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M477.89,4.49l-6.89-4.02c.27-.11,.55-.21,.81-.28l6.92,4.02c-.27,.07-.54,.16-.84,.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M478.73,4.2l-6.92-4.02c.22-.05,.41-.1,.62-.13l6.91,4.02c-.19,.03-.4,.07-.61,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M479.33,4.07L472.43,.06c.17-.03,.34-.05,.52-.05l6.91,4.02c-.18,0-.35,.02-.52,.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M479.86,4.02L472.95,0c.15,0,.3,0,.45,0l6.92,4.02c-.15,0-.3,0-.46,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M480.31,4.02L473.4,0c.15,0,.28,.03,.43,.05l6.91,4.02c-.14-.03-.29-.04-.42-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M480.74,4.07L473.82,.06c.14,.02,.27,.05,.4,.09l6.91,4.02c-.14-.04-.27-.07-.4-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M481.14,4.16l-6.91-4.02c.12,.04,.25,.08,.37,.13l6.9,4.02c-.11-.05-.24-.09-.35-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M481.49,4.29l-6.9-4.02c.11,.05,.23,.11,.34,.17l6.91,4.02c-.11-.07-.23-.12-.35-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M481.84,4.46l-6.91-4.02s.02,.02,.04,.02l6.9,4.02s-.03-.01-.04-.02h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "442.67 64.26 435.78 60.25 435.68 28.78 442.59 32.79 442.67 64.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "449.52 20.8 442.6 16.78 470.02 .95 476.93 4.96 449.52 20.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.59,32.79l-6.91-4.02c0-4.42,3.11-9.79,6.92-12l6.92,4.02c-3.83,2.2-6.94,7.57-6.93,11.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.59,32.79l-6.91-4.02c0-.44,.03-.9,.1-1.36l6.89,4.02c-.04,.46-.08,.91-.08,1.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.67,31.44l-6.89-4.02c.03-.32,.09-.64,.15-.96l6.91,4.02c-.07,.32-.13,.64-.18,.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.85,30.47l-6.91-4.02c.06-.26,.13-.53,.2-.79l6.9,4.02c-.07,.26-.14,.53-.19,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M443.04,29.68l-6.9-4.02c.07-.23,.14-.48,.21-.7l6.92,4.01c-.09,.24-.15,.47-.22,.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M443.26,28.97l-6.92-4.01c.08-.22,.15-.44,.24-.66l6.91,4.01c-.08,.22-.15,.44-.23,.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M443.49,28.31l-6.91-4.01c.07-.21,.17-.42,.25-.62l6.92,4.01c-.11,.21-.19,.42-.26,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M443.75,27.69l-6.92-4.01c.1-.21,.18-.4,.28-.61l6.92,4.02c-.1,.2-.2,.4-.27,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.03,27.09l-6.92-4.02c.1-.19,.2-.39,.3-.59l6.91,4.02c-.11,.19-.2,.39-.29,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.32,26.5l-6.91-4.02c.11-.2,.22-.39,.32-.59l6.92,4.02c-.12,.19-.22,.39-.33,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.65,25.91l-6.92-4.02c.13-.2,.25-.39,.36-.58l6.91,4.01c-.13,.19-.24,.4-.36,.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M445.01,25.32l-6.91-4.01c.14-.2,.27-.41,.4-.61l6.91,4.02c-.13,.2-.27,.4-.4,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M445.41,24.72l-6.91-4.02c.15-.21,.29-.42,.45-.62l6.91,4.01c-.15,.21-.31,.42-.46,.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M445.87,24.09l-6.91-4.01c.19-.24,.37-.47,.57-.69l6.91,4.01c-.2,.22-.38,.46-.57,.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M446.44,23.4l-6.91-4.01c.25-.29,.5-.56,.76-.81l6.92,4.02c-.27,.25-.52,.52-.77,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M447.21,22.6l-6.92-4.02c.72-.72,1.52-1.33,2.31-1.8l6.92,4.02c-.83,.47-1.6,1.08-2.32,1.8h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "459.37 34.01 459.38 36.74 451.24 45.55 451.24 45.61 459.41 44.99 459.42 47.74 448.62 48.21 448.62 45.98 459.37 34.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "468.12 24.99 463.37 46.49 461.09 47.81 465.84 26.31 468.12 24.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "469.44 28.19 480.24 27.65 480.25 30.02 469.48 41.93 469.48 39.18 477.8 30.28 477.8 30.22 469.44 30.93 469.44 28.19"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M320.11,175.53c0-4.42-3.16-6.17-6.99-3.97l-27.41,15.83c-3.8,2.21-6.94,7.58-6.93,12v2.76s-1.12,.66-1.12,.66l1.13,1.64,.03,7.46-1.2,3.18,1.22,.71,.04,15.07c.02,4.42,3.14,6.18,6.98,3.97l27.41-15.83c3.83-2.2,6.94-7.57,6.93-11.99l-.08-31.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M314.65,170.89c.4-.13,.79-.22,1.15-.25,.03,0,.07,0,.1,0,.39-.04,.77,0,1.13,.06,0,0,.03,0,.04,0,.36,.07,.69,.2,1.01,.38l-6.91-4.02s-.02-.01-.04-.02c-.11-.07-.24-.12-.36-.18-.11-.05-.24-.09-.36-.13-.09-.02-.18-.04-.26-.06,0,0-.02-.01-.04-.01-.05,0-.07-.01-.09-.02-.14-.03-.28-.04-.43-.05-.14,0-.31,0-.47,0-.04,0-.1,.01-.15,.02-.03,0-.07,0-.1,0-.09,0-.17,0-.26,.03-.2,.03-.4,.07-.61,.13-.09,.02-.18,.07-.28,.09-.06,.03-.15,.05-.22,.07-.11,.04-.2,.07-.32,.11-.32,.14-.63,.3-.97,.49l-27.43,15.83c-.79,.47-1.58,1.08-2.3,1.8-.11,.1-.21,.22-.32,.33-.04,.04-.08,.09-.13,.14-.11,.11-.21,.22-.32,.34-.19,.22-.38,.45-.57,.69-.15,.21-.31,.42-.46,.63-.13,.2-.27,.4-.4,.6-.13,.19-.25,.4-.36,.59-.01,.01-.02,.03-.03,.05h0c-.1,.18-.21,.36-.29,.54-.11,.19-.21,.39-.3,.59-.1,.2-.19,.4-.29,.6-.07,.21-.17,.42-.24,.63-.08,.21-.16,.44-.25,.65-.03,.12-.06,.24-.1,.36,0,.02,0,.05-.04,.08-.03,.09-.05,.18-.07,.27-.08,.27-.14,.54-.21,.8-.06,.33-.12,.64-.15,.96-.07,.46-.11,.91-.09,1.36l.09,31.47c0,2.2,.78,3.73,2.02,4.46l6.91,4.02c-1.25-.73-2.02-2.26-2.03-4.45l-.1-31.47c0-1.1,.2-2.27,.55-3.42,0-.01,0-.03,0-.04,.35-1.15,.86-2.3,1.48-3.37h0c.62-1.06,1.35-2.05,2.15-2.91,.03-.04,.07-.09,.12-.13,.81-.86,1.69-1.6,2.62-2.13l27.41-15.83c.46-.25,.88-.44,1.29-.59,.09-.03,.18-.06,.24-.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M295.54,193.33c2.14-1.24,3.76-1.68,4.49-1.66l-.84,4.23c-.83,.08-1.99,.38-3.44,1.21-3.27,1.89-5.8,5.6-5.77,10.25,0,4.18,2.17,5.55,5.84,3.44,1.23-.71,2.6-1.8,3.41-2.64l.63,3.3c-.76,.88-2.45,2.32-4.68,3.6-6.26,3.62-9.51,1-9.52-4.94-.02-7.1,4.38-13.62,9.87-16.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "310.07 189.68 310.1 196.41 315.74 193.15 315.75 196.08 310.12 199.33 310.13 206.14 307.49 207.67 307.46 200.87 301.84 204.11 301.83 201.19 307.46 197.94 307.43 191.2 310.07 189.68"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "251.97 77.1 252.11 125.36 186.41 163.3 186.27 115.04 251.97 77.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M218.64,107.68l.04,15.06c.02,8.27-3.59,14.32-9.72,17.85-5.86,3.39-9.34,1.65-9.36-6.92l-.04-14.97,5.26-3.05,.04,15.45c.02,4.63,1.56,6.11,4.25,4.54,2.79-1.61,4.3-4.72,4.29-9.46l-.05-15.45,5.28-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M241.95,94.22l-6.53,16.92,6.94,9.75-6.08,3.51-2.11-3.66c-.89-1.37-1.44-2.43-2.09-3.61l-.08,.05c-.5,1.83-1.05,3.54-1.79,5.85l-1.93,5.99-6.04,3.49,6.72-17.5-6.56-9.5,6.09-3.51,2.04,3.73c.7,1.23,1.22,2.25,1.77,3.46l.09-.04c.54-2.05,1.01-3.52,1.56-5.4l1.98-6.04,6.02-3.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M129.04,576.55c3.65-5.57,9.34-10.79,17.11-15.28,17.88-10.33,42.52-14.3,65.6-11.98,14.59,1.47,28.55,5.46,39.77,11.98,13,7.56,20.12,17.21,21.44,27.07,1.59,12.17-5.66,24.67-21.78,33.98-24.46,14.14-61.59,16.4-90.02,6.84-5.5-1.83-10.67-4.12-15.36-6.84-21.29-12.38-26.85-30.4-16.75-45.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M160.08,590.46s-3.48,7.2,1.73,9.44c5.2,2.23,5.2-1.24,14.88,6.69,9.67,7.93,18.39,4.6,19.79,2.99,1.04-1.19,1.14-9.12-20.37-20.02l-16.04,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,599.9c5.19,2.23,5.19-1.24,14.88,6.69,9.67,7.93,18.4,4.6,19.78,2.99,.17-.17,.3-.51,.33-.98-9.02,3.21-13.93-1.3-17.89-4.35-4.07-3.14-7.54-4.39-13.75-5.72-6.18-1.35-3.91-6.13-3.91-6.13-.38-.35-.99-.53-1.68-.6-.74,2.19-1.57,6.47,2.24,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M207.78,576.66s-2.9,7.43,2.45,9.26c5.37,1.82,5.09-1.65,15.36,5.51,10.26,7.16,18.71,3.15,19.97,1.45,.95-1.28,.42-9.2-21.86-18.38l-15.93,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.24,585.92c5.36,1.82,5.08-1.65,15.35,5.51,10.27,7.16,18.72,3.15,19.97,1.45,.16-.22,.26-.56,.25-1.01-8.75,3.9-13.98-.22-18.18-2.96-4.31-2.81-7.85-3.77-14.13-4.62-6.3-.85-4.39-5.81-4.39-5.81-.43-.33-1.06-.44-1.73-.44-.56,2.23-1.04,6.56,2.87,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M225.44,427.55s3.34,53.56,2.82,73.09c-.51,19.53,2.55,56.48-.57,74.75-.99,5.89-23.41,7.6-24.63,1.16-3.33-17.91-.31-59.48-.31-59.48l-10.25-75.52s21.34,.67,32.93-13.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M214.04,446.55s-11.49,57.14-15.89,76.06c-4.44,18.93-6.79,50.51-14.69,70.53-2.2,5.59-24.86,3.42-25.19-2.36-.96-16.59,14.03-62.98,14.03-62.98l2.71-71.13s24.72,1.49,39.02-10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M158.28,590.78c-.96-16.59,14.03-62.98,14.03-62.98l2.71-71.13s5.96,.35,13.71-.66l9.52,5.44s-8.96,6.41-12.12,19.69c-3.14,13.3-8.29,44.61-11.29,54.04-2.47,7.77-11.05,45.47-14.02,58.58-1.5-.84-2.47-1.84-2.54-2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M267.07,416.82s17.02-.11,18.21-10.12c.16-1.22-.73-1.64-4.65-.25-2.58,.92-3.98,2.44-5.7,1.25-1.95-1.36,2.79-5.81,1.28-6.69-1.5-.88-10.77,5.86-10.77,5.86l-2.72,1.44-.09,9.06,4.45-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M207.03,370.19s5.1-7.42,10.91-1.01c5.8,6.4,16.03,36.62,19.33,38.84,1.63,1.09,27.56-1.42,27.56-1.42,0,0-3.64,4.07,1.94,11.24,0,0-33.11,12.84-39.15,6.2-10.34-11.43-24.58-41.69-20.58-53.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M176.53,382.38c1.03-.74,34.05-19.15,38.28-15.99,4.24,3.18,13.97,18.52,11.06,41.02-2.1,16.2,1.53,40.59,1.53,40.59,0,0-32.88,24.99-52.38,8.66l1.5-12.24c4.06-33.26-13.74-52.17,0-62.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M271.42,402.92s8.26-4.32,6.43-1.97c-1.81,2.35-5.11,6.65-7.25,6.65s.81-4.67,.81-4.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.27,449.31c0-.13,.02-.26,.02-.39,0-.12,.02-.25,.04-.38,.02-.14,.04-.26,.04-.4,.02-.14,.04-.26,.05-.41,0,0,0,0,0,0v-.02c.02-.13,.04-.24,.06-.37,.03-.15,.06-.28,.08-.42,.03-.14,.07-.28,.1-.43,.04-.13,.07-.27,.12-.42,.02-.11,.06-.23,.09-.36h0s0-.05,.02-.07c.05-.13,.1-.27,.13-.41,.05-.12,.09-.28,.15-.4,.04-.13,.09-.26,.14-.4,.06-.12,.11-.25,.15-.38,.04-.11,.09-.21,.15-.32,0-.01,0-.03,0-.04t.02-.03c.04-.14,.11-.26,.16-.4,.08-.14,.14-.28,.22-.42,.06-.17,.17-.32,.25-.49,.09-.19,.19-.37,.31-.55,.02-.02,.02-.03,.02-.04,.02-.04,.03-.06,.04-.09,.19-.34,.4-.66,.62-.99,.15-.25,.33-.48,.52-.72,.11-.16,.21-.32,.34-.47,.11-.13,.2-.27,.31-.38,.11-.13,.21-.24,.32-.37,.09-.11,.2-.23,.31-.35,.03-.02,.04-.04,.07-.07,0,0,0,0,.03-.02,.07-.08,.16-.17,.22-.25,.12-.11,.22-.22,.36-.33,.11-.11,.22-.22,.34-.33,.12-.11,.24-.22,.36-.32,.05-.04,.12-.09,.18-.14,.02-.02,.04-.03,.05-.04,.05-.04,.08-.08,.13-.11,.11-.09,.23-.18,.35-.27,.13-.1,.24-.18,.36-.25,.11-.07,.22-.17,.34-.24,.11-.06,.23-.14,.33-.2,.02-.02,.07-.03,.08-.05l13.32,7.74c-.55,.31-1.1,.69-1.61,1.11,0,0-.02,0-.03,.02-.53,.41-1.02,.88-1.49,1.39,0,0-.02,.01-.03,.02-.47,.51-.92,1.05-1.34,1.61,0,0-.01,.02-.02,.03-.42,.56-.8,1.16-1.15,1.77-.03,.03-.05,.06-.07,.09-.34,.6-.66,1.23-.93,1.86,0,0-.01,.01-.01,.03-.28,.66-.55,1.32-.74,1.97h0c-.2,.66-.36,1.34-.47,2h0c-.11,.68-.16,1.33-.16,1.97l.02,4.63c0,.62,.07,1.2,.16,1.73,0,0,.02,.02,.02,.04,.11,.52,.27,.99,.45,1.43h0c.13,.28,.29,.49,.47,.73,.36,.49,.75,.93,1.24,1.21l-13.31-7.74c-.5-.28-.88-.72-1.23-1.21-.04-.05-.13-.09-.16-.16-.11-.16-.22-.34-.31-.54-.06-.15-.13-.29-.19-.45-.06-.13-.09-.28-.14-.43-.04-.13-.07-.26-.1-.4-.01-.06-.02-.11-.04-.18t0-.05c-.02-.07-.03-.12-.04-.18-.03-.11-.04-.24-.05-.37-.02-.12-.03-.26-.06-.39,0-.11-.01-.25-.02-.37,0-.13,0-.26,0-.39v-4.65c0-.13,0-.25,0-.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.28,419.24l-13.31-7.74c1.23,.72,2.53,1.31,3.87,1.85,.19,.08,.37,.15,.57,.23,1.19,.44,2.45,.78,3.72,1.07,.24,.06,.47,.15,.72,.2,1.44,.28,2.92,.46,4.43,.55,.32,.01,.63,.03,.95,.06,1.47,.04,2.97,.03,4.51-.11,.17,0,.35-.03,.54-.05,1.6-.16,3.27-.4,4.94-.76,.15-.04,.32-.07,.48-.11,1.69-.38,3.45-.87,5.22-1.46,.14-.04,.29-.08,.41-.14,1.85-.63,3.72-1.39,5.63-2.26,.13-.05,.27-.11,.37-.18,1.94-.89,3.9-1.9,5.89-3.04,2-1.16,3.97-2.41,5.92-3.77,.14-.1,.26-.19,.4-.29,1.81-1.27,3.61-2.62,5.37-4.04,.19-.15,.37-.31,.56-.46,1.73-1.41,3.42-2.89,5.08-4.42,.2-.18,.38-.36,.57-.54,1.68-1.59,3.34-3.23,4.96-4.95,.13-.14,.25-.26,.37-.4,1.73-1.83,3.41-3.73,5.03-5.7,0-.02,.06-.04,.07-.07,1.65-1.99,3.24-4.04,4.79-6.14,.01,0,.03-.03,.05-.04,.03-.04,.06-.1,.08-.15,1.4-1.89,2.73-3.83,4.04-5.78,.83-1.27,1.62-2.59,2.43-3.87,.65-1.06,1.33-2.11,1.95-3.18,.3-.53,.59-1.06,.88-1.57,1.03-1.83,2.07-3.68,3-5.54,.08-.2,.19-.37,.28-.57,1.17-2.28,2.24-4.58,3.25-6.9,.06-.12,.12-.24,.16-.37,1-2.26,1.92-4.52,2.75-6.82,.07-.16,.13-.32,.18-.48,.88-2.34,1.64-4.69,2.36-7.04,.04-.15,.09-.31,.15-.46,.66-2.26,1.25-4.52,1.79-6.76,.05-.25,.11-.47,.17-.71,.53-2.34,1-4.66,1.35-6.98,0-.04,.03-.07,.03-.11,.39-2.35,.66-4.68,.84-6.99,.02-.18,.03-.38,.04-.57,.19-2.31,.29-4.6,.28-6.86,0-2.25-.11-4.42-.31-6.52-.02-.19-.03-.38-.04-.58-.21-1.91-.48-3.75-.83-5.52-.04-.25-.08-.5-.13-.73-.36-1.71-.79-3.35-1.26-4.92-.11-.31-.21-.59-.31-.9-.5-1.47-1.04-2.88-1.64-4.22-.07-.15-.13-.32-.2-.47-.71-1.53-1.51-2.97-2.38-4.33-.12-.18-.25-.33-.37-.5-.73-1.09-1.5-2.11-2.32-3.06-.29-.35-.59-.67-.91-.99-.71-.77-1.45-1.5-2.23-2.18-.32-.28-.62-.56-.96-.83-1.08-.87-2.22-1.69-3.44-2.38,4.45,2.57,8.89,5.15,13.31,7.73,1.22,.7,2.36,1.52,3.45,2.39,.33,.26,.64,.55,.94,.81,.8,.69,1.53,1.41,2.25,2.18,.32,.33,.62,.65,.9,.99,.83,.96,1.61,1.98,2.32,3.07,.12,.17,.23,.33,.36,.5,.04,.04,.04,.07,.08,.11,.81,1.27,1.56,2.63,2.24,4.07,.02,.05,.06,.1,.07,.14,.05,.16,.12,.32,.19,.48,.41,.89,.81,1.79,1.15,2.76,.2,.48,.33,.98,.5,1.48,.11,.29,.2,.57,.29,.86,.09,.27,.19,.51,.27,.79,.27,.98,.55,2,.79,3.04,.07,.36,.14,.74,.21,1.1,.06,.25,.11,.5,.15,.75,.08,.35,.17,.69,.22,1.05,.16,.94,.3,1.89,.42,2.85,.07,.53,.12,1.06,.18,1.61,0,.2,.04,.38,.05,.58,0,.23,.06,.44,.07,.68,.07,.91,.14,1.84,.18,2.79,.03,.95,.06,1.9,.07,2.88v.18c0,.89,0,1.79-.04,2.68-.03,.95-.07,1.9-.13,2.87-.03,.44-.07,.88-.11,1.3-.03,.2-.04,.4-.04,.58-.03,.33-.04,.68-.07,1-.11,.98-.2,1.96-.34,2.92-.12,.99-.25,1.98-.42,2.99,0,.02,0,.04,0,.08,0,.03-.03,.07-.03,.11-.15,.93-.31,1.87-.48,2.81-.2,1.02-.41,2.06-.64,3.1-.07,.36-.18,.71-.23,1.06-.07,.24-.13,.47-.19,.69-.08,.45-.19,.91-.3,1.35-.26,1.05-.54,2.1-.82,3.15-.21,.75-.44,1.52-.66,2.27-.04,.15-.09,.32-.15,.47-.04,.13-.06,.27-.1,.4-.33,1.03-.65,2.04-.99,3.07-.33,1.01-.69,2.01-1.06,3.03-.07,.19-.13,.36-.19,.54-.07,.17-.11,.33-.18,.48-.23,.63-.47,1.25-.7,1.89-.37,.96-.76,1.93-1.17,2.89-.28,.69-.59,1.39-.88,2.07-.05,.13-.1,.25-.15,.36-.07,.14-.12,.28-.18,.42-.43,.97-.86,1.92-1.32,2.87-.48,1.06-.99,2.09-1.5,3.13-.09,.16-.17,.33-.26,.48-.07,.18-.18,.36-.27,.54-.43,.84-.87,1.69-1.3,2.53-.55,1.03-1.14,2.04-1.72,3.07-.29,.51-.56,1.03-.85,1.52-.12,.21-.24,.42-.35,.62-.51,.88-1.08,1.71-1.6,2.57-.8,1.29-1.6,2.61-2.44,3.87-.12,.18-.24,.39-.36,.57-1.18,1.77-2.4,3.51-3.65,5.21-.05,.07-.1,.13-.15,.19-.84,1.16-1.72,2.3-2.59,3.42-.73,.92-1.46,1.83-2.2,2.73-.02,.03-.04,.04-.07,.07,0,0-.01,.02-.02,.03-.76,.91-1.51,1.81-2.3,2.69-.75,.87-1.54,1.72-2.31,2.56-.14,.15-.26,.28-.4,.41-.12,.14-.24,.28-.38,.4-.53,.58-1.08,1.16-1.63,1.73-.83,.84-1.68,1.66-2.52,2.48-.25,.25-.51,.48-.77,.72-.22,.19-.41,.37-.61,.57-.42,.37-.83,.76-1.23,1.13-.88,.79-1.75,1.56-2.64,2.31-.39,.33-.79,.65-1.19,.97-.18,.15-.38,.31-.57,.47-.29,.22-.59,.48-.88,.71-.86,.68-1.73,1.35-2.61,1.99-.61,.45-1.24,.9-1.86,1.33-.14,.1-.27,.19-.4,.29-.11,.07-.2,.15-.33,.22-.82,.57-1.66,1.13-2.5,1.67-.85,.53-1.67,1.05-2.52,1.54-.18,.12-.39,.23-.57,.34-.64,.37-1.26,.73-1.91,1.06-.81,.44-1.61,.85-2.41,1.26-.52,.26-1.04,.5-1.56,.73-.13,.06-.25,.12-.38,.18-.18,.07-.32,.15-.47,.22-.8,.36-1.6,.69-2.39,1.02-.8,.32-1.6,.62-2.39,.9-.14,.05-.27,.1-.43,.14-.09,.03-.21,.06-.3,.11-.55,.18-1.11,.37-1.65,.53-.81,.26-1.64,.48-2.45,.69-.4,.09-.79,.17-1.18,.26-.14,.03-.32,.07-.47,.11-.26,.06-.54,.12-.78,.16-.87,.17-1.73,.31-2.59,.43-.53,.07-1.06,.11-1.57,.16-.18,.02-.36,.04-.55,.05-.19,.01-.35,.05-.53,.05-.94,.07-1.87,.11-2.8,.1-.4,0-.78-.04-1.18-.06-.32,0-.63-.03-.94-.05-.3-.02-.64,0-.95-.05-1.16-.1-2.31-.26-3.41-.49-.04,0-.06,0-.07-.02-.24-.05-.47-.13-.69-.19-1.16-.26-2.3-.55-3.4-.93-.12-.04-.24-.1-.36-.15-.17-.08-.37-.15-.55-.23-1.34-.53-2.67-1.13-3.89-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.93,409.78c-.22-.59-.44-1.2-.65-1.81l13.31,7.74c.33,.96,.7,1.87,1.05,2.78,.33,.84,.68,1.67,1.06,2.48,.25,.52,.46,1.04,.72,1.55,.78,1.59,1.61,3.11,2.51,4.54,0,.01,.02,.02,.02,.03,.8,1.26,1.67,2.45,2.57,3.58,.28,.34,.58,.67,.85,1,.67,.79,1.35,1.56,2.08,2.27,.33,.36,.68,.69,1.02,1.01,.74,.69,1.5,1.35,2.27,1.97,.32,.26,.66,.55,.98,.79,1.13,.84,2.29,1.63,3.47,2.33q-6.93-4.01-13.3-7.74c-1.21-.69-2.36-1.49-3.48-2.3-.33-.25-.66-.54-.98-.8-.79-.62-1.54-1.28-2.28-1.97-.34-.34-.69-.66-1.02-1.01-.73-.72-1.41-1.48-2.09-2.27-.27-.34-.56-.66-.83-1-.92-1.16-1.79-2.34-2.59-3.62h0c-.92-1.42-1.75-2.96-2.53-4.56-.08-.19-.2-.36-.3-.57-.15-.29-.27-.64-.4-.95-.38-.82-.73-1.66-1.08-2.52-.11-.33-.26-.62-.39-.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "336.68 413.36 323.37 405.62 319.29 407.97 332.6 415.7 336.68 413.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "336.53 359.74 323.2 352 323.37 405.62 336.68 413.36 336.53 359.74"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M333.71,390.39l-13.32-7.74v.36l13.31,7.74c0-.12,0-.24,0-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M333.7,390.74l-13.31-7.74c0,.12,0,.25-.02,.39l13.33,7.74c0-.14,0-.26,0-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M333.69,391.14l-13.33-7.74c0,.12-.02,.26-.03,.4l13.31,7.73c.02-.14,.04-.26,.04-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M333.65,391.53l-13.31-7.73c-.02,.13-.02,.26-.04,.4l13.32,7.74c.02-.14,.03-.27,.04-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M333.62,391.93l-13.32-7.74c-.02,.12-.03,.27-.05,.4l13.32,7.73c.02-.13,.03-.27,.05-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M333.57,392.32l-13.32-7.73c-.02,.13-.05,.26-.07,.4l13.31,7.74c.03-.13,.06-.26,.09-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M333.48,392.73l-13.31-7.74c-.04,.15-.06,.28-.07,.43l13.29,7.74c.04-.14,.07-.28,.09-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M333.39,393.16l-13.29-7.74c-.04,.13-.08,.28-.11,.43l13.32,7.73c.04-.14,.07-.29,.08-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.3,393.58l-13.32-7.73c-.04,.13-.07,.28-.1,.42l13.31,7.74c.03-.14,.07-.29,.11-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M333.2,394l-13.31-7.74c-.04,.15-.09,.28-.14,.42l13.31,7.74c.04-.15,.11-.28,.14-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M333.06,394.43l-13.31-7.74c-.03,.14-.08,.28-.11,.41l13.31,7.74c.05-.13,.07-.28,.12-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M332.94,394.84l-13.31-7.74c-.05,.13-.1,.29-.16,.41l13.32,7.73c.04-.13,.1-.27,.15-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M332.79,395.24l-13.32-7.73c-.04,.14-.09,.26-.14,.4l13.31,7.74c.05-.14,.1-.28,.15-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M332.64,395.65l-13.31-7.74c-.05,.12-.09,.26-.17,.39l13.31,7.74c.07-.14,.11-.27,.17-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M332.48,396.04l-13.31-7.74c-.04,.13-.1,.26-.15,.38l13.31,7.74c.06-.12,.11-.25,.15-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M332.32,396.41l-13.31-7.74c-.05,.14-.12,.26-.18,.39l13.31,7.73c.05-.12,.12-.26,.18-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M332.14,396.8l-13.31-7.73c-.07,.13-.13,.27-.22,.43l13.33,7.74c.07-.15,.14-.29,.2-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M331.94,397.23l-13.33-7.74c-.07,.15-.16,.32-.25,.48l13.33,7.74c.09-.16,.15-.33,.25-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M331.7,397.71l-13.33-7.74c-.11,.23-.25,.47-.39,.7l13.32,7.75c.13-.23,.27-.48,.4-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M331.3,398.42l-13.32-7.75c-.19,.33-.38,.64-.6,.96l13.33,7.73c.2-.31,.4-.62,.59-.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M330.7,399.36l-13.33-7.73c-.16,.24-.32,.48-.51,.72l13.31,7.74c.2-.23,.36-.48,.52-.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M330.18,400.08l-13.31-7.74c-.1,.16-.23,.32-.34,.48l13.3,7.74c.12-.16,.25-.32,.35-.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M329.83,400.56l-13.3-7.74c-.11,.12-.21,.25-.32,.37l13.31,7.74c.11-.12,.22-.25,.32-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M329.52,400.93l-13.31-7.74c-.09,.13-.2,.25-.29,.37l13.31,7.74c.1-.11,.22-.23,.29-.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M329.22,401.3l-13.31-7.74c-.12,.11-.22,.24-.34,.34l13.33,7.73c.12-.1,.21-.22,.32-.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M328.9,401.63l-13.33-7.73c-.08,.12-.19,.23-.31,.35l13.31,7.74c.11-.11,.23-.22,.33-.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M328.58,401.99l-13.31-7.74c-.11,.12-.22,.23-.34,.34l13.31,7.73c.12-.1,.23-.22,.34-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M328.23,402.32l-13.31-7.73c-.12,.11-.23,.22-.34,.32l13.29,7.74c.13-.11,.25-.21,.36-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M327.87,402.65l-13.29-7.74c-.13,.11-.25,.21-.37,.32l13.33,7.74c.12-.1,.23-.21,.33-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M327.54,402.97l-13.33-7.74c-.11,.1-.22,.19-.36,.29l13.32,7.73c.13-.09,.24-.19,.37-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.17,403.25l-13.32-7.73c-.11,.08-.24,.18-.34,.27l13.31,7.73c.11-.09,.24-.17,.35-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M326.82,403.53l-13.31-7.73c-.12,.08-.25,.16-.34,.25l13.29,7.74c.13-.1,.23-.17,.36-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M326.46,403.78l-13.29-7.74c-.12,.08-.24,.15-.37,.22l13.32,7.74c.11-.07,.22-.15,.33-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M326.13,404l-13.32-7.74c-.11,.07-.22,.15-.35,.21l13.33,7.75c.11-.07,.23-.14,.34-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M325.79,404.21l-13.33-7.75s-.04,.04-.06,.04l13.3,7.74s.05-.04,.08-.04h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "333.69 385.75 320.38 378.02 320.39 382.65 333.71 390.39 333.69 385.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "325.7 404.26 312.4 396.51 307.89 399.11 321.21 406.85 325.7 404.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "321.21 406.85 307.89 399.11 307.95 414.5 321.27 422.25 321.21 406.85"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M331.37,380.6l-13.32-7.74c.55,.33,1,.78,1.39,1.36l13.31,7.74c-.36-.58-.83-1.03-1.38-1.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M332.74,381.96l-13.31-7.74c.1,.18,.22,.36,.3,.55l13.31,7.74c-.09-.2-.19-.37-.3-.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M333.05,382.51l-13.31-7.74c.07,.15,.14,.3,.19,.46l13.31,7.74c-.04-.17-.12-.31-.19-.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M333.23,382.97l-13.31-7.74c.05,.14,.1,.28,.15,.43l13.31,7.73c-.04-.15-.08-.28-.15-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M333.38,383.39l-13.31-7.73c.04,.13,.06,.26,.1,.41l13.32,7.73c-.04-.13-.06-.28-.11-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M333.49,383.8l-13.32-7.73c.03,.12,.07,.25,.09,.39l13.31,7.74c-.03-.14-.06-.27-.09-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M333.58,384.2l-13.31-7.74c.02,.13,.04,.25,.06,.38l13.3,7.74c-.02-.13-.04-.26-.05-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M333.62,384.57l-13.3-7.74c0,.13,0,.26,.03,.39l13.32,7.74c-.02-.13-.04-.25-.04-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M333.67,384.97l-13.32-7.74c0,.13,.02,.25,.02,.38l13.33,7.73c0-.13-.03-.25-.03-.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.69,385.34l-13.33-7.73c0,.12,.01,.26,.01,.38l13.31,7.74v-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M333.69,385.74l-13.31-7.74v.02l13.31,7.73h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M331.37,380.6l-13.32-7.74c-.21-.11-.43-.21-.65-.29l13.31,7.74c.23,.09,.45,.18,.66,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M330.7,380.3l-13.31-7.74c-.19-.07-.36-.11-.57-.15l13.33,7.74c.19,.04,.37,.08,.55,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M330.15,380.15l-13.33-7.74c-.14-.04-.29-.06-.44-.07l13.31,7.73c.15,.02,.3,.04,.46,.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M329.7,380.08l-13.31-7.73c-.16,0-.29-.01-.43-.01l13.3,7.73c.15,0,.29,0,.44,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M329.26,380.06l-13.3-7.73c-.14,0-.25,0-.38,.01l13.31,7.72c.15,0,.26,0,.37,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M328.88,380.07l-13.31-7.72c-.12,0-.24,.01-.35,.03l13.3,7.74c.11-.02,.25-.04,.36-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M328.53,380.11l-13.3-7.74c-.13,.02-.24,.04-.36,.06l13.32,7.74c.11-.02,.24-.04,.34-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M328.19,380.17l-13.32-7.74c-.11,.03-.22,.05-.32,.07l13.3,7.74c.12-.02,.22-.05,.34-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M327.85,380.24l-13.3-7.74c-.12,.04-.22,.06-.34,.09l13.32,7.74c.12-.04,.22-.06,.32-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.52,380.33l-13.32-7.74c-.11,.04-.21,.07-.32,.1l13.32,7.75c.1-.04,.21-.07,.32-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M327.2,380.44l-13.32-7.75c-.11,.05-.22,.09-.32,.13l13.31,7.74c.1-.05,.21-.08,.33-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M326.88,380.56l-13.31-7.74c-.11,.04-.22,.09-.33,.14l13.32,7.74c.11-.05,.21-.09,.33-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M326.55,380.7l-13.32-7.74c-.11,.05-.21,.09-.33,.15l13.33,7.74c.09-.06,.21-.11,.32-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M326.24,380.85l-13.33-7.74c-.1,.06-.22,.12-.32,.17l13.3,7.74c.13-.06,.23-.11,.35-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M325.89,381.02l-13.3-7.74c-.1,.05-.17,.09-.26,.15l13.32,7.74c.09-.06,.17-.11,.25-.15h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "325.64 381.17 312.32 373.43 307.85 376.02 321.16 383.76 325.64 381.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "336.53 359.74 323.2 352 319.14 354.36 332.45 362.1 336.53 359.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "332.45 362.1 319.14 354.36 307.8 360.91 321.12 368.65 332.45 362.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "321.12 368.65 307.8 360.91 307.85 376.02 321.16 383.76 321.12 368.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M393.06,267.04c-.29,.22-.58,.44-.87,.66-1.76,1.37-3.51,2.8-5.23,4.28-.33,.26-.62,.53-.94,.81-1.73,1.51-3.45,3.07-5.13,4.7-.18,.17-.36,.33-.51,.5-1.67,1.63-3.33,3.31-4.94,5.04-.16,.15-.29,.3-.44,.45-1.64,1.76-3.24,3.57-4.82,5.42-.24,.3-.5,.59-.76,.89-1.5,1.79-2.98,3.62-4.42,5.49-.34,.44-.68,.89-1.02,1.34-.99,1.29-1.92,2.6-2.88,3.91-.76,1.08-1.54,2.16-2.28,3.26-.62,.89-1.2,1.79-1.79,2.69-1.51,2.27-2.96,4.6-4.38,6.96-.47,.79-.97,1.57-1.43,2.36-.51,.92-1.01,1.84-1.54,2.76-.85,1.54-1.71,3.09-2.52,4.66-.23,.44-.47,.91-.69,1.35-1.08,2.13-2.12,4.27-3.13,6.43-.13,.29-.25,.59-.4,.86-.99,2.22-1.96,4.44-2.86,6.67-.12,.31-.26,.62-.36,.93-.9,2.22-1.74,4.45-2.52,6.68-.11,.34-.22,.69-.36,1.03-.75,2.22-1.46,4.44-2.14,6.67-.1,.36-.2,.73-.3,1.07-.69,2.38-1.35,4.78-1.91,7.16l-13.31-7.74c.11-.47,.22-.95,.34-1.41,.34-1.37,.69-2.72,1.07-4.07,.15-.57,.34-1.13,.5-1.7,.11-.33,.21-.69,.29-1.02,.14-.44,.26-.88,.39-1.31,.4-1.33,.82-2.66,1.28-3.98,.16-.47,.33-.94,.49-1.41,.11-.35,.24-.68,.36-1.04,.18-.47,.33-.95,.5-1.43,.45-1.25,.93-2.5,1.42-3.76,.19-.48,.39-.98,.61-1.47,.1-.31,.25-.63,.35-.94,.18-.42,.35-.85,.52-1.27,.51-1.22,1.03-2.43,1.57-3.64,.25-.58,.52-1.16,.79-1.75,.12-.28,.26-.58,.4-.87,.16-.36,.34-.74,.49-1.1,.62-1.3,1.24-2.59,1.89-3.88,.22-.48,.49-.96,.74-1.46,.23-.44,.45-.89,.69-1.35,.3-.59,.61-1.18,.93-1.78,.5-.98,1.06-1.93,1.61-2.89,.52-.91,1-1.83,1.53-2.74,.18-.3,.34-.62,.52-.92,.28-.48,.6-.96,.91-1.44,1.4-2.37,2.87-4.67,4.38-6.96,.3-.46,.57-.96,.9-1.43,.27-.43,.6-.84,.88-1.27,.75-1.07,1.51-2.14,2.27-3.21,.49-.7,.98-1.43,1.48-2.12,.48-.63,.97-1.25,1.45-1.88,.33-.42,.65-.87,.98-1.29,.29-.35,.54-.71,.8-1.06,1-1.26,2-2.49,3.02-3.7,.19-.25,.41-.49,.62-.74,.25-.29,.5-.58,.75-.88,.5-.6,1.02-1.22,1.53-1.81,.99-1.12,1.98-2.22,3-3.31,.1-.1,.19-.2,.29-.3,.15-.16,.3-.3,.44-.46,.79-.84,1.57-1.68,2.38-2.49,.9-.92,1.81-1.83,2.74-2.71,.09-.08,.17-.18,.28-.27,.06-.07,.13-.15,.21-.22,1.11-1.06,2.24-2.1,3.37-3.12,.54-.48,1.09-.96,1.64-1.42,.3-.26,.6-.54,.92-.81,.28-.25,.55-.49,.84-.73,1.13-.95,2.26-1.88,3.41-2.78,.33-.26,.67-.52,1.02-.78,.26-.22,.55-.42,.83-.64,.51-.38,1.01-.78,1.53-1.15,1.1-.8,2.19-1.58,3.29-2.34,.22-.15,.46-.29,.66-.44,.22-.14,.41-.28,.62-.42,.66-.44,1.32-.87,1.97-1.29,1.08-.68,2.15-1.34,3.22-1.97,.26-.15,.5-.29,.76-.43,.81-.47,1.62-.93,2.44-1.36,.29-.16,.58-.3,.88-.46,.42-.23,.87-.45,1.29-.68,.32-.17,.64-.34,.95-.49,.51-.24,.99-.46,1.48-.7,.4-.19,.81-.38,1.19-.55,.15-.07,.29-.14,.44-.21,1.01-.46,2.03-.89,3.04-1.3,1.04-.4,2.08-.8,3.1-1.15,.11-.04,.22-.08,.36-.12,.41-.15,.84-.28,1.25-.41,.47-.16,.97-.34,1.44-.47,.24-.08,.47-.14,.72-.2,.48-.14,.95-.26,1.41-.39,.35-.09,.69-.2,1.03-.29,.35-.09,.71-.16,1.08-.23,.45-.11,.92-.22,1.38-.31,.23-.05,.45-.11,.67-.15,.4-.07,.79-.12,1.18-.2,.55-.09,1.09-.18,1.64-.27,.18-.02,.35-.07,.52-.09,.42-.05,.83-.08,1.26-.13,.55-.06,1.1-.12,1.68-.16,.15-.02,.31-.04,.45-.05,.39-.02,.75,0,1.1-.04,.66-.02,1.32-.05,1.97-.05,.2,0,.37-.02,.54-.02,.29,0,.55,.03,.8,.04,.83,.02,1.67,.06,2.46,.12,.23,.03,.47,.02,.69,.03,.18,.02,.33,.06,.52,.07,1.21,.13,2.41,.3,3.6,.53,.11,.01,.19,.02,.3,.04,.02,0,.03,0,.04,.02,1.69,.33,3.31,.8,4.9,1.34,.12,.05,.27,.07,.38,.12,.11,.03,.22,.08,.33,.12,.7,.26,1.39,.55,2.08,.85,.3,.14,.62,.25,.93,.4,.98,.45,1.93,.95,2.87,1.49,4.43,2.58,8.87,5.15,13.3,7.73-.94-.54-1.89-1.03-2.88-1.49-.29-.14-.57-.24-.87-.36-.69-.32-1.41-.61-2.14-.88-.23-.08-.48-.15-.71-.24-1.57-.55-3.2-1.01-4.88-1.34-.13-.04-.25-.04-.38-.07-1.15-.23-2.34-.39-3.57-.52-.41-.04-.82-.07-1.23-.11-.8-.05-1.59-.1-2.4-.11-.47,0-.94-.02-1.39-.02-.63,0-1.27,.04-1.9,.06-.54,.03-1.08,.05-1.64,.09-.54,.04-1.04,.11-1.58,.17-.62,.06-1.25,.13-1.88,.22-.5,.09-1.03,.17-1.51,.25-.67,.11-1.32,.23-1.97,.37-.43,.09-.88,.19-1.3,.28-.73,.18-1.47,.35-2.21,.55-.43,.12-.86,.23-1.29,.36-.77,.22-1.53,.46-2.3,.71-.39,.12-.77,.24-1.15,.37-2.28,.79-4.62,1.72-6.98,2.79-.38,.17-.75,.35-1.13,.52-.83,.4-1.65,.8-2.49,1.23-.42,.21-.85,.43-1.27,.65-1.1,.58-2.21,1.17-3.33,1.82-1.99,1.15-3.98,2.41-5.94,3.7-.2,.15-.41,.28-.62,.42-1.83,1.24-3.66,2.56-5.47,3.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "321.16 383.76 307.85 376.02 204.31 435.79 217.63 443.53 321.16 383.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M209.58,457.41l.02,4.63c0,5.1,3.64,7.14,8.08,4.57l103.52-59.77,.07,15.41,11.32-6.55c9.97,29.71,38.91,38.68,73.01,19,42.19-24.37,76.32-83.47,76.19-131.97-.14-48.53-34.48-68.11-76.7-43.73-34.08,19.68-62.89,61.99-72.64,103.1l-11.32,6.55,.03,15.11-103.53,59.77c-4.43,2.56-8.06,8.77-8.04,13.88Zm136.38-76.27c-.1-37.69,26.4-83.6,59.2-102.55,32.8-18.94,59.47-3.71,59.58,33.98,.11,37.69-26.39,83.59-59.19,102.53-32.8,18.94-59.5,3.74-59.59-33.97Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M403.4,277.82c-32.95,19.01-59.55,65.1-59.44,102.94,.11,37.85,26.88,53.1,59.84,34.1,32.9-19,59.52-65.09,59.4-102.94-.1-37.85-26.89-53.11-59.79-34.1Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "332.45 362.1 332.6 415.7 321.27 422.25 321.12 368.65 332.45 362.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M206.68,363.47s-1.65,8.45,.32,12.84c1.94,4.38-4.22,6.42-8.34,5.33-3.98-1.06-9.78-4.82-8.15-7.26,3.17-4.72,1.9-11.6-.03-14.88-1.93-3.28,16.2,3.98,16.2,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M189.77,337.95s-8,5.79-5.16,15.81c1.57,5.55,7.27,12.2,10.97,14.96,3.71,2.76,12.43,9.84,16.07,3.1,3.65-6.74,7.63-26.01-.8-34.37-8.44-8.35-21.08,.5-21.08,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M211.7,341.29c-3.38,2.97-8.38,6.48-16.62,6.83-8.23,.35-4.82,4.02-4.02,5.22,.68,1.01,2.91,6.69,.03,3.98-1.1-1.02-3.8-3.47-4.55-1.23-.74,2.23,5.43,7.69,5.66,9.59,.19,1.35-14.24-10.34-14.01-20.96,.22-10.63,8.26-21.64,22.25-17.17,10.06,3.21,8.66,3.24,11.81,5.25,2.8,1.79,2.92,5.39-.56,8.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.75,352.89s5.22,11,12.43,13.63c6.66,2.44,9.17-.07,11.4-3.12,0,0-.09,11-6.41,11.22-4.6,.17-12.42-1.16-15.08-7.33-1.16-2.71,.46-8.23-2.3-10.24-2.75-2.01-.05-4.16-.05-4.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M233.47,433.87s16.99-.6,17.92-10.63c.1-1.23-.78-1.61-4.67-.13-2.56,.99-3.94,2.55-5.67,1.42-1.99-1.31,1.25-4.36-.31-5.21-1.51-.84-9.2,4.64-9.2,4.64l-2.69,1.53,.19,9.06,4.43-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M171.22,388.06c1.13-2.49,5.83-6.7,11.81-.47,5.98,6.23,17.05,36.17,20.4,38.29,1.67,1.05,27.51-2.18,27.51-2.18,0,0-3.53,4.18,2.24,11.18,0,0-32.76,13.77-38.96,7.27-10.65-11.13-28.38-42.45-23-54.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "670.09 661.07 897.4 528.97 733.05 433.59 505.73 565.69 670.09 661.07"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728.99,373.37c-.19-.89-.45-1.71-.78-2.44,0-.01-.01-.03-.02-.04-.28-.6-.65-1.11-1.03-1.6-.13-.16-.24-.33-.38-.48-.47-.49-.95-.92-1.51-1.24,37.97,22.07,75.93,44.13,113.9,66.2,.56,.33,1.06,.76,1.5,1.24,.14,.15,.26,.32,.38,.48,.17,.21,.37,.39,.51,.62,.18,.3,.37,.62,.52,.95,0,0,0,.02,.01,.04,0,0,0,.02,.01,.04,.11,.22,.22,.46,.3,.7,.08,.24,.16,.48,.25,.73,.06,.23,.12,.46,.17,.71,.03,.09,.04,.19,.06,.29,0,.04,0,.05,.02,.08,.02,.1,.04,.19,.05,.29,.04,.21,.08,.43,.1,.66,.03,.22,.04,.44,.06,.67,.02,.21,.03,.42,.05,.65,0,.21,.01,.44,.02,.66v.04l.25,90.21-113.9-66.2-.25-90.2c0-1.06-.11-2.06-.29-2.96,0-.03,0-.05-.01-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "653.93 551.86 540.04 485.67 540.29 575.88 654.18 642.07 653.93 551.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M668.59,522.71s-.09,.07-.13,.1c-.54,.44-1.07,.91-1.6,1.39-.06,.06-.11,.11-.17,.15-.52,.49-1.03,1-1.53,1.53-.04,.05-.07,.09-.12,.14-.53,.57-1.05,1.15-1.55,1.76,0,.01-.01,.02-.03,.03-.51,.62-1,1.25-1.48,1.9-.02,.05-.05,.09-.08,.13-.42,.56-.81,1.13-1.19,1.71-.26,.39-.5,.79-.75,1.18-.21,.34-.43,.67-.62,1.02-.09,.15-.18,.29-.25,.44-.33,.57-.63,1.13-.92,1.71-.04,.08-.09,.15-.12,.24-.35,.69-.68,1.39-.99,2.08-.02,.06-.04,.11-.07,.16-.3,.68-.58,1.38-.83,2.07-.02,.06-.04,.12-.08,.18-.26,.72-.51,1.45-.72,2.17,0,.04-.02,.08-.04,.12-.2,.7-.39,1.41-.56,2.12-.01,.07-.03,.12-.04,.19-.17,.72-.31,1.44-.43,2.16,0,.01,0,.04,0,.05-.12,.73-.2,1.45-.26,2.16,0,.06-.01,.11-.01,.16-.05,.71-.09,1.43-.09,2.12l-113.89-66.19c0-.26,0-.54,.02-.82,0-.29,.02-.59,.04-.88,0-.15,.02-.29,.03-.44,0-.04,0-.08,0-.12,0-.11,.01-.22,.02-.33,.04-.3,.07-.6,.1-.9,.04-.3,.08-.62,.13-.92,0-.02,0-.04,.01-.05h0c.04-.29,.09-.59,.15-.88,.07-.32,.12-.63,.19-.95,.02-.12,.06-.25,.1-.37,0-.05,.03-.11,.04-.17,.04-.14,.06-.28,.1-.42,.08-.32,.17-.65,.26-.97,.05-.25,.13-.48,.21-.73,.01-.04,.04-.08,.05-.13,0-.04,.02-.07,.03-.11,.1-.31,.19-.62,.3-.95,.11-.31,.22-.62,.33-.94,.03-.06,.05-.12,.07-.18,.01-.04,.04-.09,.06-.14,.06-.19,.14-.38,.21-.58,.11-.29,.24-.59,.36-.89,.1-.23,.21-.47,.31-.7,0,0,0-.02,.02-.03,.01-.05,.03-.1,.05-.15,.14-.29,.27-.59,.4-.88,.16-.32,.32-.65,.47-.97,.03-.05,.05-.11,.09-.16,.02-.05,.05-.1,.07-.15,.13-.26,.27-.52,.41-.78,.18-.34,.36-.67,.57-1.02,.06-.12,.13-.24,.19-.36,.06-.08,.09-.16,.14-.23,.19-.33,.4-.65,.6-.97,.21-.33,.4-.67,.62-.99,.06-.07,.1-.15,.14-.22,.38-.57,.77-1.12,1.17-1.66,.26-.36,.55-.71,.82-1.06,.23-.29,.46-.59,.7-.88,.23-.28,.47-.56,.71-.83,.24-.27,.47-.54,.72-.8,.04-.04,.08-.08,.12-.12,.03-.03,.06-.06,.09-.09,.18-.19,.36-.38,.54-.56,.26-.26,.52-.52,.78-.77,.08-.07,.15-.14,.23-.21,.05-.06,.12-.11,.18-.17,.13-.12,.26-.26,.41-.37,.27-.24,.53-.48,.81-.71,.12-.11,.25-.2,.36-.3,.05-.04,.09-.08,.15-.11,.09-.08,.18-.17,.29-.25,.27-.21,.53-.41,.81-.61,.19-.15,.39-.28,.59-.42,.02-.01,.06-.04,.08-.06,.04-.02,.07-.05,.12-.08,.26-.18,.51-.35,.77-.51,.26-.16,.51-.32,.77-.48,.06-.03,.11-.06,.17-.1l157.15-90.73c.19-.11,.38-.22,.57-.32,.25-.14,.5-.26,.74-.38,.17-.08,.33-.16,.5-.23,.03-.02,.07-.04,.11-.05,.04-.02,.09-.05,.13-.07,.25-.11,.5-.22,.74-.31,.25-.1,.48-.19,.73-.27,.05-.02,.1-.04,.14-.05,.04,0,.07-.03,.11-.04,.17-.06,.33-.11,.49-.15,.25-.08,.5-.15,.75-.21,.14-.04,.25-.06,.38-.09,.05,0,.11-.02,.15-.03,.07-.01,.15-.04,.22-.05,.26-.05,.53-.1,.8-.13,.18-.03,.34-.04,.5-.05,.05,0,.12-.01,.17-.01,.05,0,.11-.01,.15-.02,.29-.02,.58-.04,.87-.03,.12,0,.24,.01,.37,.01,.1,0,.2,.01,.29,.02,.1,0,.2,0,.29,.01,.36,.03,.71,.08,1.06,.15,0,0,.01,0,.02,0,.11,.03,.21,.06,.3,.09,.33,.07,.66,.15,.96,.26,.03,0,.05,.02,.08,.03,.49,.18,.96,.4,1.41,.66,37.97,22.07,75.93,44.12,113.9,66.2-.45-.26-.92-.48-1.41-.66-.37-.14-.74-.24-1.13-.33-.07-.01-.13-.04-.21-.05-.44-.09-.9-.15-1.38-.17-.08,0-.18,0-.28-.02-.45-.02-.93-.02-1.41,.03-.04,0-.09,0-.14,.01-.49,.04-1,.12-1.53,.23-.05,.02-.11,.03-.17,.04-.52,.11-1.05,.27-1.6,.44-.04,.02-.08,.03-.13,.04-.58,.2-1.15,.43-1.74,.69-.03,.01-.06,.03-.08,.05-.61,.27-1.22,.59-1.84,.95l-157.15,90.73c-.62,.36-1.22,.75-1.83,1.16-.04,.03-.08,.06-.11,.08-.57,.4-1.14,.82-1.69,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M672.22,520.19c-10.11,5.83-18.32,20.05-18.29,31.67l.25,90.21,4.6-2.66-.25-90.21c-.04-8.72,6.12-19.38,13.7-23.75l157.14-90.72c7.6-4.38,13.78-.86,13.81,7.86l.25,90.21,4.57-2.65-.26-90.21c-.03-11.61-8.29-16.33-18.4-10.48l-157.15,90.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "666.02 468 750.89 418.68 689.52 383.06 604.65 432.39 666.02 468"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "654.07 432.35 654.08 435.96 674.42 447.78 674.41 444.16 654.07 432.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "674.41 444.16 674.42 447.78 718.49 422.33 718.48 418.72 674.41 444.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "654.07 432.35 674.41 444.16 718.48 418.72 698.15 406.9 654.07 432.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M730.66,322.17c-1.69-.99-3.4-1.97-5.09-2.97-.77-.43-1.8-.37-2.96,.29l5.1,2.96c1.16-.66,2.2-.72,2.95-.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M730.66,322.17l-5.09-2.97c-.11-.06-.22-.11-.34-.15l5.1,2.97c.12,.04,.24,.09,.33,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M730.33,322.02l-5.1-2.97c-.1-.03-.18-.06-.29-.08l5.11,2.97c.1,.01,.2,.04,.28,.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M730.05,321.94l-5.11-2.97c-.08-.02-.17-.03-.24-.03l5.11,2.96c.07,.01,.16,.02,.24,.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M729.81,321.9l-5.11-2.96c-.07,0-.14-.01-.22-.01l5.1,2.97c.08,0,.15,0,.22,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M729.59,321.9l-5.1-2.97c-.06,0-.13,0-.19,0l5.11,2.96c.06,0,.13,0,.19,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M729.41,321.9l-5.11-2.96c-.06,0-.11,0-.18,.02l5.1,2.97c.08,0,.13-.02,.19-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M729.21,321.92l-5.1-2.97c-.06,0-.14,.02-.19,.03l5.12,2.96s.12-.02,.17-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M729.05,321.95l-5.12-2.96c-.06,0-.11,.02-.16,.04l5.09,2.97c.06-.02,.12-.03,.18-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M728.86,321.99l-5.09-2.97c-.06,.02-.11,.03-.19,.04l5.11,2.97c.05-.01,.11-.03,.16-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M728.7,322.03l-5.11-2.97s-.1,.04-.15,.06l5.11,2.96s.11-.04,.16-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M728.53,322.09l-5.11-2.96c-.06,.02-.12,.04-.17,.07l5.1,2.96c.06-.03,.11-.04,.17-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M728.36,322.15l-5.1-2.96c-.06,.01-.11,.04-.17,.07l5.1,2.96c.06-.02,.12-.04,.17-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M728.19,322.22l-5.1-2.96c-.06,.02-.12,.05-.17,.07l5.11,2.97c.05-.03,.11-.05,.16-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M728.03,322.3l-5.11-2.97c-.06,.03-.11,.06-.17,.09l5.09,2.96c.07-.03,.11-.06,.18-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M727.85,322.39l-5.09-2.96s-.1,.04-.14,.07l5.1,2.96c.06-.02,.1-.05,.13-.07h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M636.78,435.56l.02,7.14c0,.32,.03,.61,.08,.89v.04c.06,.26,.15,.51,.23,.72t0,.02c.09,.18,.21,.34,.33,.48,.03,.04,.06,.09,.1,.14,.14,.15,.29,.28,.46,.37l-5.11-2.97c-.15-.1-.32-.22-.44-.37-.05-.05-.08-.1-.12-.15-.06-.06-.11-.11-.15-.18-.07-.08-.11-.17-.17-.28,0,0,0,0,0-.01v-.02c-.03-.06-.05-.13-.08-.21-.04-.07-.07-.14-.08-.22-.02-.07-.04-.14-.06-.21,0-.04,0-.06,0-.09,0,0,0-.01,0-.03-.01-.03-.02-.05-.03-.09,0-.06-.02-.13-.02-.2,0-.07,0-.12-.01-.19,0-.06-.01-.14-.02-.19v-.22l-.02-7.15,5.1,2.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "674.99 433.35 658.52 432.59 671.32 427.53 674.99 433.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "677.49 406.43 673.33 404.01 670.81 433.61 674.99 436.03 677.49 406.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "701.46 392.59 697.3 390.16 673.33 404.01 677.49 406.43 701.46 392.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "677.49 406.43 674.99 436.03 703.25 419.71 701.46 392.59 677.49 406.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "693.35 414.82 674.99 436.03 703.25 419.71 701.46 392.59 693.35 414.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "732.04 380.56 726.93 377.59 631.68 432.59 636.78 435.56 732.04 380.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "728.16 327.03 723.05 324.07 723.2 375.47 728.31 378.43 728.16 327.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "728.31 378.43 723.2 375.47 636.09 425.77 641.2 428.72 728.31 378.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M636.78,435.56l.02,7.14c0,2.62,1.86,3.69,4.14,2.37l86.98-50.22c2.3-1.32,4.13-4.53,4.13-7.14l-.02-7.15-95.26,54.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "641.05 377.33 641.2 428.72 728.31 378.43 728.16 327.03 641.05 377.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "641.19 427.64 727.37 377.88 727.22 327.57 641.05 377.33 641.19 427.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "641.05 377.33 635.95 374.36 636.09 425.77 641.2 428.72 641.05 377.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "728.16 327.03 723.05 324.07 635.95 374.36 641.05 377.33 728.16 327.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "636.62 379.83 631.51 376.86 631.68 432.59 636.78 435.56 636.62 379.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "727.72 322.46 722.62 319.5 635.65 369.72 640.74 372.68 727.72 322.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M727.72,322.46c2.3-1.32,4.16-.26,4.17,2.37l.16,55.73-95.26,54.99-.16-55.73c0-2.63,1.84-5.82,4.12-7.15l86.98-50.22Zm-86.52,106.26l87.11-50.29-.15-51.4-87.11,50.3,.15,51.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M631.51,376.86c0-.07,0-.13,.01-.19,0-.07,0-.13,0-.2,0-.07,.01-.14,.02-.2,0-.07,0-.14,.01-.21,0-.07,.02-.14,.04-.21v-.02c0-.07,.02-.13,.02-.19,.03-.07,.04-.14,.06-.21,.02-.07,.03-.15,.04-.22,0-.07,.03-.15,.07-.22,0-.06,.03-.11,.04-.17,0,0,0,0,0-.01,0,0,0-.02,0-.04,.03-.07,.05-.14,.08-.21,.02-.08,.04-.15,.06-.22,.03-.07,.05-.13,.08-.2,.02-.07,.05-.14,.07-.2,.03-.05,.05-.1,.07-.15,0,0,0-.01,0-.02,0-.01,0-.03,.01-.04,.02-.06,.06-.13,.08-.19,.04-.07,.07-.15,.11-.22,.05-.08,.08-.16,.12-.25,.06-.1,.1-.19,.16-.28,0,0,0,0,0,0,.02-.03,.03-.05,.03-.07h.01s0,0,0,0c.09-.16,.21-.33,.32-.49,.07-.11,.16-.24,.25-.35,0-.01,.01-.02,.01-.03,.06-.07,.13-.15,.18-.22,.05-.07,.11-.13,.16-.2,.06-.06,.1-.13,.16-.19,.05-.06,.1-.12,.17-.18,0,0,.01-.02,.03-.03,0,0,.01-.02,.01-.02,.05-.05,.09-.09,.12-.13,.06-.07,.11-.12,.17-.18,.07-.06,.12-.11,.18-.17,.06-.06,.12-.11,.19-.17,.04-.02,.06-.05,.09-.07,.02,0,.02-.01,.02-.02,.03-.02,.05-.04,.08-.06,.06-.04,.11-.09,.17-.14,.07-.04,.13-.09,.19-.13,.04-.04,.12-.08,.18-.11,.04-.04,.12-.08,.17-.11,0,0,.04,0,.05-.02l5.09,2.96c-.28,.16-.55,.36-.81,.57-.01,0-.02,.01-.04,.02-.26,.22-.51,.45-.75,.7,0,0-.01,.02-.02,.03-.24,.26-.48,.53-.68,.82h0s-.02,.01-.02,.01c-.21,.29-.4,.6-.59,.91,0,0,0,.02,0,.04-.37,.63-.68,1.32-.88,2h0c-.11,.34-.18,.69-.25,1.02v.02h0c-.04,.34-.07,.68-.07,1l-5.11-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M691.23,407.95c1.17-.68,2.11-.13,2.11,1.21s-.93,2.97-2.1,3.65c-1.17,.68-2.12,.13-2.12-1.21,0-1.33,.93-2.97,2.11-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M691.13,407.94c1.1-.64,2-.12,2.01,1.14,0,1.28-.89,2.84-2,3.48-1.12,.64-2.01,.12-2.02-1.16,0-1.27,.89-2.82,2.01-3.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M663.39,373.48l-2.51-1.44s0,0,0,0l2.51,1.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M663.4,373.49l-2.51-1.44s.04,.03,.06,.04l2.53,1.44s-.05-.02-.08-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M663.48,373.52l-2.53-1.44s.06,.02,.08,.02l2.52,1.44s-.05-.02-.07-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M663.56,373.55l-2.52-1.44s.04,.02,.07,.02l2.53,1.44s-.05,0-.07-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M663.63,373.57l-2.53-1.44s.07,0,.09,0l2.53,1.44s-.06,0-.08,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M663.72,373.57l-2.53-1.44s.06,0,.1,0l2.53,1.44h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M663.81,373.57l-2.53-1.44s.06,0,.1-.01l2.52,1.44s-.07,0-.09,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M663.9,373.56l-2.52-1.44s.07-.02,.11-.03l2.53,1.44s-.07,.02-.11,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M664.02,373.53l-2.53-1.44c.07-.01,.12-.04,.17-.06l2.53,1.44c-.06,.02-.11,.04-.17,.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M664.19,373.48l-2.53-1.44c.07-.03,.13-.06,.19-.09l2.53,1.43c-.07,.04-.13,.07-.19,.1h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M664.38,373.38l-2.53-1.43c.17-.1,.31-.22,.45-.36l2.52,1.43c-.14,.15-.29,.26-.44,.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M664.82,373.03l-2.52-1.43c.04-.05,.1-.11,.15-.16l2.53,1.43c-.05,.06-.1,.11-.15,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M664.97,372.87l-2.53-1.43s.07-.09,.12-.14l2.51,1.44s-.06,.09-.1,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M665.07,372.73l-2.51-1.44s.05-.08,.07-.12l2.52,1.44s-.05,.08-.09,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M665.16,372.61l-2.52-1.44s.06-.08,.08-.12l2.53,1.43s-.05,.08-.08,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M665.25,372.49l-2.53-1.43s.04-.08,.08-.11l2.52,1.43s-.05,.08-.07,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M665.32,372.37l-2.52-1.43s.04-.07,.06-.12l2.53,1.44s-.05,.07-.06,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M665.38,372.26l-2.53-1.44s.04-.07,.05-.12l2.53,1.45s-.04,.07-.05,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M665.44,372.15l-2.53-1.45s.04-.07,.06-.11l2.52,1.44s-.04,.07-.06,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M665.49,372.03l-2.52-1.44s.03-.08,.04-.12l2.52,1.43s-.03,.08-.04,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M665.54,371.9l-2.52-1.43s.03-.09,.04-.13l2.52,1.43s-.03,.08-.04,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M665.58,371.78l-2.52-1.43s.03-.1,.04-.15l2.54,1.44s-.04,.09-.05,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M665.63,371.64l-2.54-1.44s.03-.11,.03-.15l2.53,1.44c0,.05-.02,.11-.02,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M665.66,371.48l-2.53-1.44c.02-.06,.03-.13,.03-.19l2.53,1.43c0,.07-.02,.12-.04,.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M665.69,371.29l-2.53-1.43c.03-.09,.03-.18,.03-.27,0-.43-.17-.73-.42-.87l2.53,1.44c.24,.14,.4,.44,.4,.87,0,.09,0,.18-.01,.26h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M660.91,375.42l-2.52-1.44c.15-.1,.31-.22,.44-.36l2.52,1.43c-.13,.15-.29,.26-.44,.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M661.35,375.06l-2.52-1.43c.05-.05,.11-.11,.15-.16l2.53,1.44c-.05,.06-.1,.11-.16,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M661.51,374.91l-2.53-1.44s.07-.08,.12-.13l2.52,1.44s-.07,.09-.11,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M661.62,374.77l-2.52-1.44s.05-.08,.08-.12l2.53,1.44s-.06,.08-.09,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M661.71,374.65l-2.53-1.44s.06-.08,.08-.11l2.53,1.43s-.06,.08-.08,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M661.79,374.53l-2.53-1.43s.04-.07,.07-.12l2.52,1.44s-.05,.07-.07,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M661.86,374.41l-2.52-1.44s.04-.07,.06-.12l2.52,1.44s-.05,.08-.06,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M661.92,374.3l-2.52-1.44s.03-.07,.06-.11l2.52,1.44-.06,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M661.97,374.19l-2.52-1.44s.04-.07,.05-.12l2.52,1.44s-.04,.08-.06,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M662.03,374.07l-2.52-1.44s.03-.08,.04-.12l2.53,1.44s-.03,.08-.05,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M662.08,373.94l-2.53-1.44s.04-.08,.04-.13l2.52,1.44s-.03,.08-.04,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M662.12,373.82l-2.52-1.44s.03-.09,.05-.14l2.52,1.45s-.02,.09-.04,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M662.16,373.68l-2.52-1.45c0-.05,.02-.1,.03-.15l2.52,1.43c0,.06-.02,.11-.04,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M662.2,373.52l-2.52-1.43c0-.07,.02-.13,.04-.19l2.52,1.43c-.01,.06-.02,.13-.03,.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M662.23,373.33l-2.52-1.43c0-.09,.01-.18,.01-.27,0-.43-.17-.73-.41-.87l2.53,1.44c.24,.14,.4,.44,.4,.87,0,.09,0,.18-.01,.26h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M660.89,372.3l-2.54-1.44c.07-.04,.13-.07,.19-.1l2.52,1.44c-.05,.02-.13,.06-.18,.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M661.06,372.2l-2.52-1.44c.06-.02,.11-.04,.16-.06l2.52,1.45s-.1,.03-.16,.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M661.22,372.15l-2.52-1.45s.08-.01,.11-.02l2.52,1.44s-.08,.01-.12,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M661.34,372.12l-2.52-1.44s.07,0,.1,0l2.53,1.43s-.07,0-.11,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M661.45,372.11l-2.53-1.43s.07,0,.1,0l2.52,1.44h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M661.53,372.11l-2.52-1.44s.05,0,.09,0l2.52,1.44s-.05,0-.08,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M661.62,372.11l-2.52-1.44s.04,.01,.07,.02l2.53,1.44s-.05-.01-.08-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M661.7,372.14l-2.53-1.44s.05,.01,.08,.02l2.52,1.44s-.05,0-.07-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M661.77,372.15l-2.52-1.44s.04,.03,.06,.04l2.53,1.44s-.04-.02-.07-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M661.83,372.19l-2.53-1.44s0,0,0,0l2.53,1.44s0,0,0,0h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M659.94,375.52l-2.52-1.44c-.25-.14-.39-.44-.4-.86,0-.09,0-.18,.02-.27l2.51,1.44c0,.09,0,.18,0,.26,0,.43,.15,.73,.4,.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M659.55,374.39l-2.51-1.44c0-.06,0-.13,.02-.19l2.53,1.44c-.02,.06-.03,.12-.04,.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M659.59,374.21l-2.53-1.44s.02-.1,.04-.15l2.53,1.43c-.01,.06-.03,.11-.04,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M659.63,374.05l-2.53-1.43s.03-.09,.04-.14l2.53,1.43s-.02,.1-.04,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M659.66,373.91l-2.53-1.43s.04-.09,.05-.13l2.53,1.43s-.04,.09-.05,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M659.71,373.78l-2.53-1.43s.03-.08,.04-.12l2.53,1.44s-.03,.08-.04,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M659.75,373.66l-2.53-1.44s.04-.07,.06-.12l2.53,1.43s-.04,.08-.06,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M659.81,373.53l-2.53-1.43s.04-.08,.06-.11l2.52,1.43s-.04,.08-.05,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M659.87,373.42l-2.52-1.43s.04-.08,.07-.12l2.52,1.44s-.04,.08-.06,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M659.93,373.31l-2.52-1.44s.05-.07,.07-.11l2.52,1.43s-.05,.07-.07,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M660,373.19l-2.52-1.43s.04-.08,.08-.11l2.53,1.43s-.07,.07-.09,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M660.09,373.07l-2.53-1.43s.05-.09,.08-.13l2.52,1.43s-.05,.09-.07,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M660.17,372.95l-2.52-1.43c.04-.05,.08-.1,.11-.14l2.52,1.44s-.07,.09-.11,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M660.28,372.81l-2.52-1.44c.05-.06,.1-.11,.14-.16l2.53,1.43c-.04,.06-.1,.11-.15,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M660.42,372.65l-2.53-1.43c.15-.15,.3-.26,.45-.36l2.54,1.44c-.18,.1-.33,.21-.47,.36h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M656.48,377.56l-2.52-1.44s0,0,.02,0l2.52,1.44s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M656.49,377.57l-2.52-1.44s.04,.02,.06,.03l2.53,1.44s-.04-.02-.07-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M656.56,377.6l-2.53-1.44s.05,.02,.07,.03l2.53,1.44s-.05-.02-.08-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M656.64,377.63l-2.53-1.44s.04,0,.07,.02l2.53,1.44s-.05-.02-.07-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M656.71,377.65l-2.53-1.44s.06,0,.08,0l2.53,1.44s-.06,0-.09,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M656.8,377.65l-2.53-1.44h.1l2.52,1.44s-.06,0-.08,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M656.88,377.65l-2.52-1.44s.06,0,.11-.01l2.51,1.44s-.06,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M656.98,377.64l-2.51-1.44s.07-.01,.11-.03l2.52,1.44s-.07,.02-.12,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M657.1,377.61l-2.52-1.44c.06-.02,.1-.03,.16-.05l2.52,1.43s-.1,.04-.16,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M657.25,377.55l-2.52-1.43c.06-.03,.13-.06,.18-.1l2.53,1.44c-.07,.04-.13,.07-.2,.09h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M657.46,377.46l-2.53-1.44c.16-.09,.32-.21,.46-.35l2.51,1.43c-.14,.14-.28,.26-.44,.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M657.89,377.1l-2.51-1.43c.04-.05,.11-.11,.15-.16l2.52,1.44c-.05,.05-.1,.11-.16,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M658.05,376.95l-2.52-1.44s.06-.09,.11-.14l2.52,1.44s-.07,.09-.1,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M658.15,376.81l-2.52-1.44s.05-.08,.08-.13l2.53,1.44s-.06,.08-.1,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M658.25,376.69l-2.53-1.44s.06-.07,.09-.12l2.52,1.44s-.05,.08-.07,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M658.32,376.57l-2.52-1.44s.04-.07,.07-.11l2.52,1.44s-.04,.07-.07,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M658.39,376.46l-2.52-1.44s.04-.09,.06-.12l2.52,1.44s-.05,.08-.07,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M658.46,376.34l-2.52-1.44s.03-.07,.06-.11l2.52,1.43s-.03,.09-.05,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M658.51,376.22l-2.52-1.43s.03-.07,.05-.12l2.53,1.44s-.04,.07-.07,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M658.57,376.11l-2.53-1.44s.04-.08,.05-.12l2.53,1.44s-.03,.08-.04,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M658.62,375.98l-2.53-1.44s.04-.08,.05-.13l2.52,1.44s-.03,.08-.04,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M658.66,375.86l-2.52-1.44s.03-.09,.04-.14l2.53,1.43s-.04,.1-.05,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M658.71,375.71l-2.53-1.43c.01-.05,.03-.11,.04-.15l2.52,1.44s-.03,.1-.04,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M658.74,375.56l-2.52-1.44c0-.07,.02-.13,.03-.19l2.52,1.44c0,.06-.01,.12-.02,.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M658.76,375.37l-2.52-1.44c0-.09,.01-.18,.01-.26,0-.44-.16-.74-.41-.88l2.54,1.43c.24,.15,.4,.45,.4,.88,0,.08,0,.18-.02,.27h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M713.36,338.66c1.39-.82,2.54-.18,2.56,1.42l.07,5.59-63.04,37.14-.06-5.59c-.03-1.61,1.1-3.57,2.48-4.39l57.99-34.18Zm-48.98,34.72c.74-.44,1.34-1.5,1.32-2.35,0-.86-.61-1.21-1.36-.77-.75,.44-1.35,1.5-1.35,2.36,.02,.86,.64,1.21,1.39,.76h0Zm-3.47,2.04c.75-.44,1.35-1.5,1.33-2.36,0-.86-.62-1.21-1.35-.77-.76,.44-1.35,1.5-1.35,2.36,0,.86,.62,1.2,1.37,.77h0Zm-3.45,2.04c.75-.44,1.33-1.5,1.32-2.36,0-.87-.62-1.21-1.36-.77-.75,.44-1.35,1.5-1.35,2.36,.01,.86,.63,1.2,1.38,.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M664.34,370.26c.75-.44,1.35-.09,1.36,.77,.01,.86-.59,1.91-1.32,2.35-.75,.44-1.37,.1-1.39-.76,0-.86,.59-1.92,1.35-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M660.89,372.3c.73-.44,1.35-.09,1.35,.77,.01,.85-.58,1.92-1.33,2.36-.74,.44-1.36,.09-1.37-.77,0-.86,.59-1.92,1.35-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M657.42,374.34c.74-.44,1.35-.1,1.36,.77,0,.85-.58,1.92-1.32,2.36-.75,.43-1.37,.09-1.38-.77,0-.86,.59-1.92,1.35-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M652.88,377.23l.06,5.59,63.04-37.14,.5,42.43c.02,1.6-1.1,3.57-2.48,4.39l-58,34.18c-1.39,.81-2.52,.17-2.55-1.43l-.57-48.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "695.63 389.32 695.64 391.44 658.35 412.96 658.35 410.85 695.63 389.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "695.62 384.55 695.63 386.68 658.34 408.21 658.34 406.08 695.62 384.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "695.61 379.8 695.61 381.91 658.33 403.44 658.32 401.32 695.61 379.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "695.58 368.69 695.58 370.8 658.3 392.33 658.3 390.22 695.58 368.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "695.59 373.46 695.59 375.57 658.31 397.1 658.31 394.98 695.59 373.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "711.03 372.44 711.06 381.98 698.16 389.42 698.13 379.9 711.03 372.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "711 359.75 711.02 369.28 698.12 376.73 698.09 367.21 711 359.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M784.39,595.46c-22.85,13.2-22.96,34.58-.25,47.77,22.69,13.19,59.6,13.19,82.45,0,22.86-13.19,22.97-34.57,.29-47.76-22.72-13.19-59.64-13.19-82.48,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "654 464.41 654.01 467.52 680.34 482.81 680.32 479.71 654 464.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "680.32 479.71 680.34 482.81 752.94 440.89 752.94 437.79 680.32 479.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "654 464.41 680.32 479.71 752.94 437.79 726.62 422.49 654 464.41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "731.05 438 734.79 440.18 739.91 437.22 736.17 435.05 731.05 438"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "721.26 432.31 724.98 434.48 730.1 431.52 726.37 429.35 721.26 432.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "726.15 435.15 729.88 437.32 735 434.37 731.27 432.2 726.15 435.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "714.41 432.31 716.45 433.49 725 428.56 722.95 427.37 714.41 432.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "704.53 438 706.58 439.19 715.13 434.26 713.08 433.07 704.53 438"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "674.92 455.11 676.95 456.29 685.51 451.35 683.46 450.17 674.92 455.11"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "714.65 436.11 718.4 438.27 723.52 435.32 719.78 433.15 714.65 436.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "719.56 438.96 723.3 441.13 728.42 438.17 724.69 436 719.56 438.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "708.08 439.91 711.81 442.07 716.93 439.12 713.19 436.95 708.08 439.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "724.47 441.81 728.2 443.98 733.32 441.02 729.59 438.85 724.47 441.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "694.66 443.7 696.71 444.89 705.26 439.96 703.21 438.76 694.66 443.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "712.99 442.76 716.73 444.92 721.84 441.97 718.1 439.8 712.99 442.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "701.5 443.7 705.23 445.88 710.35 442.92 706.62 440.75 701.5 443.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "728.96 444.42 732.52 446.48 737.64 443.53 734.08 441.46 728.96 444.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "717.9 445.61 721.62 447.77 726.74 444.82 723.01 442.65 717.9 445.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "706.4 446.55 710.13 448.72 715.25 445.77 711.52 443.6 706.4 446.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "694.91 447.51 698.65 449.68 703.76 446.72 700.04 444.55 694.91 447.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "684.79 449.41 686.83 450.59 695.38 445.66 693.34 444.47 684.79 449.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "711.3 449.41 715.03 451.58 720.16 448.62 716.43 446.45 711.3 449.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "699.82 450.36 703.55 452.53 708.67 449.57 704.94 447.41 699.82 450.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "688.33 451.31 692.07 453.48 697.19 450.52 693.46 448.35 688.33 451.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "704.73 453.21 708.46 455.37 713.58 452.42 709.84 450.25 704.73 453.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "693.23 454.16 696.97 456.33 702.09 453.37 698.36 451.2 693.23 454.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "698.15 457.01 701.88 459.17 707 456.22 703.25 454.05 698.15 457.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "686.66 457.96 690.39 460.12 695.51 457.17 691.78 455 686.66 457.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "691.56 460.81 695.29 462.97 700.41 460.02 696.68 457.86 691.56 460.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "680.08 461.76 683.81 463.92 688.93 460.97 685.19 458.81 680.08 461.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "668.18 462.94 671.91 465.11 682.29 459.13 678.56 456.95 668.18 462.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "695.46 463.76 699.01 465.83 731.01 447.35 727.46 445.29 695.46 463.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "684.98 464.61 688.71 466.78 693.42 464.06 693.83 463.82 690.1 461.65 684.98 464.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "689.06 467.45 692.61 469.53 697.73 466.57 694.19 464.5 689.06 467.45"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "682.47 471.26 686.04 473.32 691.16 470.37 687.6 468.3 682.47 471.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "735.55 440.62 739.1 442.68 744.22 439.73 740.66 437.66 735.55 440.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "673.08 465.79 676.81 467.97 682.34 464.77 678.61 462.6 673.08 465.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "677.99 468.64 681.72 470.81 693.42 464.06 688.71 466.78 684.98 464.61 677.99 468.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "681.76 455.11 685.49 457.28 690.61 454.32 686.88 452.15 681.76 455.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "665.05 460.81 667.08 461.99 675.64 457.06 673.59 455.87 665.05 460.81"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M737.41,569.02c-.47,.1-24.61-.04-19.4,7.88,3.38,5.12,8.18,5.92,11.8,5.93,3.61,0,10.26-2.03,11.87-1.13,1.62,.91,9.69,5.76,14.49,.56,.98-1.06,1.68-4.04,1.09-5.92-.57-1.88-17.18-7.84-19.85-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.01,576.89c3.38,5.12,8.18,5.92,11.8,5.93,3.61,0,10.26-2.03,11.87-1.13,1.62,.91,9.69,5.76,14.49,.56,.53-.57,.96-1.71,1.17-2.93-3.37,4.4-11.37,3.4-13.56,2.03-2.51-1.54-6.15-2.25-9.32-1.61-3.18,.66-10.02,.13-13.39-2.75-2.05-1.74-1.9-3.81-1.46-5.16-2.15,1.14-3.12,2.75-1.6,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M742.74,536.98s-1.99,23.57-2.81,36.18c-.27,4.28,8.03,7.65,17.12,3.55l4.5-38.36-18.82-1.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M843.79,507.11s-10.68,33.31-32.17,31.97l-24.1-42.86,56.27,10.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M827.59,518.9s1.69,18.03-12.58,20.13c-14.28,2.09-28.43-13.78-42.13-14.36-1.23-.06-7.83-7.3-11.47,14.44l-.31,1.94-18.46-1.94s.99-30.32,5.67-39.09c6.7-12.58,44.87-2.52,44.87-2.52l34.4,21.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M779.7,612.55l.02,9.04c.01,4.57,3.03,9.15,9.03,12.64,12.09,7.03,31.78,7.03,43.95,0,6.13-3.54,9.19-8.18,9.17-12.81,0-3.02-.01-6.03-.02-9.05,0,4.64-3.05,9.28-9.17,12.82-12.17,7.02-31.85,7.02-43.94,0-6.02-3.49-9.02-8.07-9.03-12.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M779.7,612.55l.02,9.04c0,.09,0,.18,0,.27l-.03-9.04v-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M779.7,612.82l.03,9.04c.03,.6,.09,1.2,.21,1.79l-.03-9.04c-.12-.6-.19-1.19-.21-1.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M779.91,614.61l.03,9.04c.11,.58,.27,1.17,.5,1.75l-.02-9.04c-.22-.58-.39-1.17-.5-1.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M780.41,616.36l.02,9.04c.22,.6,.5,1.19,.83,1.77l-.03-9.04c-.33-.59-.61-1.18-.83-1.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M781.24,618.13l.03,9.04c.35,.62,.77,1.24,1.25,1.86l-.03-9.04c-.48-.61-.9-1.23-1.25-1.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M782.49,619.98l.03,9.04c.55,.7,1.21,1.4,1.92,2.07l-.02-9.04c-.73-.67-1.38-1.36-1.93-2.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M784.42,622.05l.02,9.04c1.12,1.02,2.43,2.01,3.94,2.92l-.02-9.04c-1.51-.92-2.82-1.89-3.94-2.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M788.35,624.98l.02,9.04c.13,.07,.25,.15,.38,.22,2.08,1.21,4.36,2.21,6.81,2.99l-.04-9.04c-2.43-.79-4.73-1.79-6.8-2.99-.13-.07-.25-.15-.38-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M795.53,628.19l.04,9.04c1.88,.61,3.84,1.1,5.87,1.46l-.02-9.04c-2.02-.37-4.01-.86-5.89-1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M801.42,629.65l.02,9.04c1.31,.24,2.63,.41,3.97,.56l-.02-9.05c-1.35-.14-2.67-.32-3.97-.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M805.39,630.2l.02,9.05c1.14,.11,2.3,.19,3.45,.22l-.02-9.03c-1.17-.04-2.31-.12-3.45-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M808.84,630.44l.02,9.03c1.06,.04,2.12,.04,3.19,.02l-.04-9.05c-1.06,.03-2.12,.03-3.17,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M812.01,630.44l.04,9.05c1.01-.03,2.05-.08,3.06-.17l-.03-9.04c-1.01,.09-2.05,.14-3.07,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M815.08,630.28l.03,9.04c1.01-.08,2.02-.19,3.02-.33l-.03-9.06c-.99,.15-2.01,.26-3.02,.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M818.09,629.94l.03,9.06c1.04-.15,2.06-.33,3.09-.54l-.03-9.04c-1.02,.2-2.05,.39-3.09,.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M821.19,629.41l.03,9.04c1.1-.23,2.18-.5,3.23-.8l-.02-9.04c-1.06,.3-2.15,.57-3.23,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M824.42,628.62l.02,9.04c1.31-.37,2.56-.8,3.78-1.28l-.02-9.03c-1.22,.47-2.49,.9-3.78,1.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M828.2,627.35l.02,9.03c1.58-.62,3.08-1.33,4.48-2.15,6.13-3.54,9.19-8.18,9.17-12.81l-.02-9.05c0,4.64-3.05,9.28-9.17,12.82-1.39,.81-2.9,1.53-4.47,2.16h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M788.87,599.73c-12.17,7.02-12.24,18.42-.14,25.46,12.09,7.02,31.77,7.02,43.94,0,12.18-7.04,12.23-18.42,.15-25.46-12.11-7.03-31.78-7.04-43.95,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M801.9,542.42c0,.31,.06,.62,.16,.92,0,.03,.02,.06,.03,.08,.1,.29,.25,.57,.43,.84,.02,.04,.06,.09,.08,.14,.19,.27,.44,.52,.71,.77,.19,.17,.43,.33,.64,.48,.18,.12,.33,.26,.53,.37,.54,.31,1.13,.56,1.75,.77,.22,.09,.46,.15,.69,.22,.29,.07,.58,.15,.88,.22,.36,.07,.71,.14,1.08,.18,.1,.01,.17,.03,.26,.04,.5,.06,.99,.08,1.48,.09,.09,0,.18,0,.27,0,.48,0,.97-.03,1.46-.07,.08-.01,.15-.02,.23-.03,.47-.06,.95-.14,1.42-.25,.09-.02,.18-.04,.27-.07,.41-.1,.81-.22,1.2-.36,.08-.03,.18-.05,.26-.08,.47-.18,.91-.39,1.34-.64,1.75-1,2.62-2.34,2.62-3.65l.2,69.45c0,1.33-.87,2.65-2.63,3.65-.39,.23-.82,.44-1.28,.62-.02,0-.05,.01-.07,.02-.07,.03-.12,.05-.19,.07-.27,.11-.53,.2-.81,.27-.15,.04-.31,.07-.46,.11-.07,.02-.16,.04-.25,.06-.07,.02-.15,.04-.22,.06-.3,.06-.59,.11-.88,.16-.11,0-.22,.02-.33,.02-.07,0-.15,.03-.21,.04-.11,0-.22,.03-.32,.04-.29,.02-.59,.04-.88,.05h-.52c-.13,0-.27,0-.4,0-.33,0-.66-.04-.99-.07-.04,0-.07,0-.11-.01-.09-.02-.18-.03-.28-.04-.25-.03-.5-.06-.73-.11-.12-.02-.22-.06-.33-.08-.3-.06-.6-.14-.88-.22-.15-.05-.32-.07-.48-.12-.12-.04-.25-.09-.37-.14-.1-.04-.22-.09-.33-.13-.44-.17-.87-.36-1.25-.59-.04-.03-.07-.05-.11-.06-.18-.12-.31-.25-.48-.36-.2-.14-.41-.28-.59-.44,0-.01-.04-.02-.06-.04-.21-.21-.4-.4-.55-.6-.04-.04-.05-.09-.08-.14-.04-.05-.07-.1-.11-.15-.07-.09-.12-.17-.17-.25-.09-.17-.18-.33-.23-.51-.02-.02-.02-.05-.03-.07,0-.03,0-.07-.02-.11-.03-.1-.07-.21-.09-.32-.04-.16-.05-.34-.05-.51,0-.02,0-.05,0-.08l-.17-60.14-.04-9.23v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M804.52,538.76c-3.48,2.01-3.5,5.26-.04,7.27,3.47,2.01,9.09,2.03,12.57,0,3.48-2.01,3.5-5.27,.03-7.27-3.47-2.01-9.07-2.01-12.56,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M746.33,542.41c-.21-.07-.41-.15-.6-.21-.13-.04-.25-.08-.38-.11-.11-.02-.23-.05-.35-.08-.15-.02-.29-.04-.44-.06-.09-.01-.17-.02-.25-.03-.2-.01-.38-.01-.55-.01h-.12c-.22,.01-.43,.04-.63,.09-.05,0-.1,.01-.15,.03-.16,.04-.31,.08-.46,.13-.04,.02-.1,.04-.15,.06-.2,.07-.38,.15-.55,.26l60.04-34.89s.04-.02,.06-.03c.13-.07,.27-.14,.42-.2,.02-.01,.05-.02,.07-.03,.06-.02,.1-.04,.15-.06,.07-.02,.14-.05,.21-.07,.09-.02,.18-.05,.25-.06,.05-.01,.1-.02,.15-.03,.03,0,.06,0,.08-.02,.17-.03,.34-.05,.52-.05h.03s.09,0,.12,0c.14,0,.26,0,.4,0,.06,0,.1,.01,.14,.01,.09,0,.18,.01,.28,.03,.07,0,.15,0,.22,.02,.07,.02,.14,.04,.2,.04,.13,.02,.24,.05,.36,.07,.06,.01,.13,.02,.18,.04,.07,.01,.12,.04,.2,.06,.19,.06,.4,.13,.59,.21,.07,.03,.14,.04,.21,.07,.04,.02,.08,.04,.12,.06,.35,.15,.7,.32,1.07,.53l41.89,24.19-60.04,34.9-41.88-24.19c-.38-.21-.73-.38-1.08-.52-.11-.05-.23-.09-.33-.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M706.23,586.83c-.47,.09-24.61-.04-19.4,7.87,3.38,5.12,8.18,5.93,11.8,5.93,3.63,0,10.26-2.04,11.88-1.13,1.62,.9,9.69,5.75,14.48,.56,.99-1.05,1.67-4.04,1.09-5.92-.58-1.88-17.19-7.83-19.84-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.82,594.7c3.38,5.12,8.18,5.93,11.8,5.93,3.63,0,10.26-2.04,11.88-1.13,1.62,.9,9.69,5.75,14.48,.56,.52-.57,.97-1.7,1.17-2.92-3.36,4.4-11.36,3.4-13.57,2.03-2.49-1.53-6.15-2.26-9.31-1.61-3.17,.66-10.04,.13-13.39-2.75-2.05-1.76-1.9-3.81-1.46-5.17-2.14,1.14-3.12,2.76-1.61,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M711.54,554.79s-1.98,23.56-2.81,36.18c-.27,4.28,8.04,7.65,17.14,3.56l8.22-37.61-22.55-2.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M812.6,524.91s-10.68,33.31-32.17,31.97l-24.1-42.87,56.27,10.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M796.39,536.71s1.7,18.03-12.58,20.13c-14.26,2.1-27.47-12.33-41.17-17.73-1.15-.44-4.91-3.94-8.55,17.8l-4.17,1.94-18.47-1.94s.99-30.32,5.67-39.09c6.71-12.58,44.88-2.52,44.88-2.52l34.39,21.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M733.92,425.29s-11.67-5.75-17.44-.97c-5.78,4.77-5.9,6.54-2.28,6.63,3.64,.08,13.37,.59,12.25,1.79-1.12,1.19-4.49,2.26-3.49,3.31,1.01,1.03,11.01-2.46,11.01-2.46l4.7-6.44-4.75-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M808.98,429.07s11.97-2.77,14.35,9.46c2.51,12.97-24.04,13.1-24.04,13.1,0,0-22.63,1.97-30.01,.45-9.85-2.04-36.91-16.44-36.91-16.44,0,0,.38-7.86,5.22-10.71,0,0,25.08,10.93,33.93,11.14,9.63,.22,35.33-7.05,37.46-7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M764.85,458.02s-3-14.03,20.48-22.44c23.49-8.41,37.94-8.11,38.24,4.99,.3,13.09-5.78,30.57-6.62,36.47-.66,4.68-2.85,15.96,2.81,29.55,5.63,13.45,8.26,26.27-28.93,28.45-6.5,.37-30.67,.25-27.25-14.82,4.28-18.81,3.97-46.6,1.27-62.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M698.2,469.39s-12.69-2.91-14.14-10.26c-1.47-7.35-.45-8.81,2.41-6.58,2.87,2.24,10.74,7.99,10.63,6.35-.11-1.63-2.04-4.6-.6-4.78,1.43-.17,6.98,8.86,6.98,8.86l-.41,7.95-4.86-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M771.13,445.97s10.81-5.71,15.59,5.92c5.07,12.34-20.1,19-20.1,19,0,0-21.06,7.55-28.42,7.86-9.76,.39-38.44-7.35-38.44-7.35,0,0-1.28-7.94,2.74-11.98,0,0,26.07,4.75,34.52,2.78,9.2-2.15,32.1-15.76,34.1-16.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M786.62,420.6s2.45,9.93-2.38,15.96c-2.62,3.27,7.81,6.66,16.22,2.37,0,0,.75-16.99,6.99-22.9l-20.83,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M787.21,427.72s5.92-.94,9.39-2.75l.38,.25,1.88,2.74,1.1-1.58s-1.89,10.34-14.39,8.1c0,0,1.27-2.72,1.64-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M786.37,380.77s-9.6,4.49-11.52,17c-1.82,11.84-5.54,22.08,.33,27.2,5.94,5.2,27.81,3.87,34.98-11.24,7.17-15.11-1.92-39.84-23.78-32.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M799.19,423.71s-2.83,20.12,7.01,34.1c5.58,7.93,5.71,13.96,4.92,17.6-.77,3.62,15.7-11.15,8.56-27.94-7.12-16.78-14.13-23.76-14.13-23.76h-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M772.2,395.98c-.09,1.89,1.21,5.82,5.04,7.39,5.37,2.19,11.73,1.94,12.31,5.56,.59,3.63,1.92,13.78,6.57,16.93,5.97,4.03,6.54-.61,9.02-3.37,3.38-3.76,12.23-17.75,5.14-32.99,0,0-5.14-11.99-19.27-9.98,0,0-18.13,2.35-18.81,16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M794.25,417.94c-2.63,2.53-6.1,3.1-7.78,1.24-1.68-1.86-.92-5.41,1.69-7.96,2.63-2.54,6.1-3.11,7.79-1.25,1.67,1.86,.92,5.42-1.69,7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M798.81,422.52s8.07-5.06,9.43-.96c1.03,3.09-7.4,7.08-10.25,6.3-2.83-.77-.71-4.46,.82-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M747.73,543.07c-4.69-2.7-8.5-.53-8.5,4.85-.02,5.41,3.76,11.94,8.43,14.65l41.89,24.19c4.68,2.7,8.47,.54,8.48-4.83,.04-5.42-3.76-11.96-8.42-14.65l-41.88-24.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M797.19,581.78l.16-61.92,66.67-38.74-.17,61.92c-.01,2.96-1.06,5.04-2.74,6.02-22.23,12.91-44.44,25.83-66.67,38.74,1.68-.99,2.74-3.07,2.75-6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M785.68,502.46c-.23-.08-.45-.16-.67-.22-.13-.04-.29-.08-.41-.12-.14-.04-.26-.06-.4-.09-.16-.03-.32-.05-.48-.07-.11,0-.21-.02-.3-.03-.2,0-.4-.02-.59,0h-.15c-.22,.01-.46,.04-.69,.09-.05,.01-.12,.02-.16,.04-.18,.04-.36,.09-.52,.15-.06,.02-.11,.03-.17,.06-.2,.08-.41,.19-.6,.29,10.39-6.04,20.79-12.08,31.19-18.13l35.51-20.64c.16-.08,.33-.16,.48-.22,.03-.02,.07-.03,.1-.04,.05-.01,.11-.04,.16-.05,.08-.03,.16-.06,.24-.09,.09-.03,.19-.04,.28-.06,.06,0,.11-.03,.16-.04,.04,0,.06-.01,.09-.02,.2-.04,.38-.05,.57-.07h.18c.15,0,.29-.01,.45,0,.05,0,.11,.01,.16,.01,.08,0,.18,.02,.28,.04,.08,0,.17,0,.26,.02,.07,.01,.15,.03,.23,.05,.13,.03,.26,.05,.39,.09,.07,.01,.13,.02,.2,.04,.07,.02,.14,.04,.21,.07,.22,.07,.44,.15,.67,.23,.08,.03,.15,.04,.24,.08,.04,.01,.09,.04,.13,.07,.39,.16,.78,.35,1.18,.59l.78,.44c.61,.35,1.2,.77,1.77,1.23,.17,.14,.34,.31,.52,.46,.28,.25,.58,.48,.85,.75,.12,.12,.25,.26,.36,.39,.09,.1,.19,.2,.29,.3,.12,.14,.25,.26,.37,.4,.26,.31,.52,.61,.77,.93,.07,.11,.17,.24,.26,.36,.04,.05,.07,.1,.11,.15,.08,.12,.18,.23,.27,.35,.18,.27,.35,.54,.53,.81,.17,.26,.34,.54,.5,.8,.01,.02,.03,.04,.04,.08,0,0,0,0,0,.02,.14,.23,.27,.46,.39,.69,.15,.26,.28,.52,.41,.8,.11,.24,.23,.49,.34,.73,0,0,.01,.01,.01,.03,0,.02,.02,.04,.02,.05,.12,.28,.23,.56,.35,.84,.11,.29,.22,.59,.31,.89,.05,.15,.09,.29,.14,.44,.02,.07,.04,.12,.05,.18,.04,.11,.06,.22,.11,.33,.08,.36,.18,.72,.25,1.08,.05,.22,.07,.43,.11,.65,.02,.11,.04,.22,.07,.33,.01,.11,.03,.21,.04,.31,.08,.62,.12,1.24,.12,1.84l-66.67,38.74c0-.7-.05-1.42-.16-2.16-.02-.11-.05-.23-.07-.35-.11-.67-.26-1.35-.48-2.03-.02-.07-.04-.14-.06-.21-.23-.74-.5-1.47-.81-2.2,0-.02-.03-.05-.04-.07-.32-.73-.68-1.46-1.09-2.17,0-.02-.02-.04-.03-.06-.41-.69-.84-1.36-1.32-2-.04-.07-.09-.13-.14-.19-.43-.58-.88-1.12-1.35-1.63-.1-.12-.22-.24-.33-.35-.37-.39-.77-.74-1.16-1.09-.18-.16-.37-.33-.56-.49-.58-.45-1.15-.88-1.76-1.22l-.77-.44c-.4-.23-.8-.42-1.18-.59-.12-.06-.24-.1-.37-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M787.22,503.2c-5.2-3-9.41-.6-9.43,5.37l-.17,61.93c-.02,5.96,4.17,13.23,9.36,16.22l.77,.45c5.18,2.99,9.42,.6,9.43-5.37l.16-61.92c.03-5.97-4.18-13.23-9.36-16.22l-.77-.44Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.72,453.84c-6.84,3.95-6.88,10.36-.09,14.31,6.8,3.94,17.85,3.94,24.7,0,6.83-3.95,6.87-10.35,.07-14.3-6.8-3.95-17.85-3.95-24.68,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M593.9,456.62c-4.19,2.42-4.21,6.34-.04,8.76,4.16,2.42,10.92,2.41,15.1,0,4.19-2.41,4.21-6.33,.05-8.74-4.16-2.42-10.92-2.42-15.11,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "590.82 461.73 612.02 461.73 616.71 433.38 586.15 433.38 590.82 461.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M590.67,427.77c-5.99,3.46-6.03,9.06-.07,12.52,5.94,3.47,15.62,3.46,21.61,0,5.98-3.46,6.02-9.06,.07-12.52-5.94-3.46-15.63-3.46-21.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M592.48,428.83c-4.98,2.87-5.01,7.53-.07,10.41,4.94,2.87,12.99,2.87,17.97,0,4.96-2.87,5-7.53,.05-10.41-4.95-2.87-12.98-2.87-17.96,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610.39,439.24c-4.98,2.87-13.03,2.87-17.97,0-1.42-.83-2.43-1.81-3.01-2.85,.3-1.52,1.46-2.99,3.48-4.16,4.75-2.74,12.43-2.74,17.15,0,1.97,1.15,3.11,2.61,3.43,4.11-.61,1.06-1.63,2.05-3.08,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M605.66,437.53c1.92-1.37,4.87-2.28,4.69-8.15-.19-5.87,7.54-2.2,7.58-6.63,.11-11.03,8.91-14.41,2.85-13.27-6.07,1.14-11,3.61-14.42,11.18-3.4,7.59-13.33,17.49-5.9,18.06,0,0,2.87,.47,5.2-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M597.44,422.24s-6.22-.06-5.48-6.07c1.33-10.96-3.98-8.6-5.81-12.77-2.48-5.69-5.94,.04-5.33,4.62,.58,4.57-2.84,9.31,6.9,19.9,3.41,3.72,5.62,12.01,14.01,10.26,8.38-1.76-6.51-8.13-4.28-15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M582.43,413.14l.31-.11s.91,2.49,3.07,3.13c-2.36-4.31-2.31-11.1-2.3-11.41h.33c0,.06-.03,3.64,.81,7.23,1.31-1.32,.84-3.22,.84-3.24l.33-.08s.56,2.25-1.08,3.7c.44,1.73,1.08,3.43,2.03,4.72,.44,.59,.98,1.28,1.6,2.08,1.51,1.95,3.45,4.45,5.15,7.05,.41-.69-.11-2.46-.38-3.15l.31-.11c.11,.28,.99,2.66,.25,3.55,2.27,3.51,4.06,7.16,3.73,9.89l-.32-.04c.39-3.28-2.42-8.02-5.37-12.16-3.75-.26-5.17-2.05-5.23-2.12l.26-.2s1.34,1.64,4.71,1.96c-1.18-1.64-2.37-3.18-3.37-4.46-.63-.81-1.16-1.5-1.61-2.09-.16-.22-.31-.45-.45-.69-2.59-.53-3.58-3.33-3.63-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M605.14,428.35c-.47-.91,.69-2.8,.84-3.03l.27,.18c-.46,.73-1.04,1.99-.87,2.6,1.9-1.94,4-3.75,5.63-5.17,.66-.58,1.25-1.09,1.72-1.52,1.04-.94,1.88-2.29,2.55-3.7-1.16-1.53-.32-3.31-.29-3.38l.3,.15s-.73,1.54,.14,2.89c1.33-2.94,1.91-6,1.92-6.05l.32,.05c-.04,.27-1.15,6.09-3.9,9.41,1.94-.22,3.11-2.14,3.12-2.16l.29,.17c-.07,.1-1.41,2.35-3.73,2.37-.16,.18-.32,.35-.49,.51-.48,.43-1.08,.95-1.74,1.52-1.07,.94-2.34,2.04-3.63,3.24,2.91,.28,4.31-.88,4.34-.89l.2,.25s-1.2,1.03-3.61,1.03c-.39,0-.81-.04-1.26-.09-3.24,3.05-6.45,6.65-6.69,9.54l-.33-.03c.19-2.4,2.34-5.26,4.89-7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M602.1,438.56c4.75-1.75,10.12-9.35,7.09-17.88-3.03-8.53-2.59-9.48,.51-13.65,3.09-4.16-.93-5.37,0-10.8,1.03-6.05-15.86,12.32-13.77,19.33,2.09,7.01-8.91,21.04,3.03,23.1,.77,.14,2.93-.02,3.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M600.22,428.05l.32,.09c-.05,.15-1.03,3.74,2.48,5.02,1.26-4.37,.56-8.88-.17-13.31-3.37-1.02-3.33-5.2-3.33-5.24h.33s-.03,3.84,2.93,4.87c0-.02,0-.03,0-.04-.41-2.5-.82-4.87-.85-7.13-.02-1.1,.08-2.12,.23-3.1l-.19,.16c-1.68-2.1-.73-5.51-.69-5.65l.32,.09s-.91,3.31,.58,5.28c.99-6,4.69-9.46,4.74-9.5l.22,.25c-.05,.04-4.86,4.54-4.88,12.2,3.21-1.61,3.08-4.73,3.07-4.86l.33-.02s.17,3.57-3.4,5.26c.04,2.2,.43,4.53,.84,6.98,.37,2.26,.77,4.62,.89,7.03,1.99-1.06,1.35-6.14,1.34-6.2l.33-.04c.04,.23,.71,5.58-1.65,6.59,.15,4.07-.55,8.21-3.5,12.04l-.26-.21c1.29-1.68,2.14-3.39,2.68-5.13-3.81-1.38-2.71-5.39-2.7-5.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M648.17,312.97l-4,10.36,4.28,5.96-3.74,2.17-1.31-2.24c-.53-.83-.87-1.49-1.28-2.22l-.05,.03c-.28,1.12-.65,2.19-1.09,3.59l-1.19,3.68-3.71,2.13,4.14-10.73-4.01-5.82,3.71-2.14,1.27,2.27c.42,.75,.74,1.37,1.1,2.1,.39-1.26,.65-2.15,1.01-3.31l1.2-3.7,3.68-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M665.27,303.1l.84,16-3.18,1.83-.22-6.19c-.07-1.94-.14-4.29-.15-6.68l-.06,.04c-.44,2.36-1.03,5.04-1.58,7.3l-1.73,7.42-2.52,1.45-1.54-5.49c-.47-1.66-.98-3.71-1.31-5.67l-.04,.03c-.08,2.26-.13,4.84-.24,6.96l-.23,6.4-3,1.72,.86-16.97,4.32-2.5,1.42,4.69c.44,1.63,.9,3.43,1.23,5.18l.06-.04c.4-2.13,.89-4.6,1.34-6.69l1.52-6.35,4.23-2.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "672.24 299.08 672.27 312.41 677.96 309.12 677.97 312.25 669.03 317.42 668.98 300.96 672.24 299.08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M754.97,322.08c1.68-.98,2.97-1.33,3.55-1.32l-.66,3.36c-.67,.05-1.59,.3-2.74,.97-2.59,1.49-4.6,4.45-4.6,8.14,0,3.32,1.73,4.41,4.64,2.74,.99-.58,2.09-1.44,2.72-2.1l.5,2.63c-.59,.69-1.95,1.83-3.69,2.85-5,2.89-7.58,.8-7.58-3.92-.03-5.66,3.48-10.83,7.85-13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M766.02,315.69c1.62-.94,2.82-1.25,3.68-1.29l-.72,3.44c-.57,.02-1.59,.14-3.02,.95-1.41,.82-2.1,1.95-2.1,2.82,0,1.06,.83,1.05,2.69,.78,2.54-.37,3.76,.46,3.76,2.78,0,2.78-1.86,6.23-5.82,8.51-1.64,.95-3.28,1.39-4.09,1.34l.66-3.48c.88,.01,2.23-.26,3.62-1.05,1.5-.87,2.29-2.03,2.29-3.12,0-1.03-.69-1.22-2.43-.94-2.4,.42-3.96-.19-3.97-2.61,0-2.82,2.05-6.16,5.45-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M778,308.78c1.63-.94,2.82-1.24,3.7-1.3l-.73,3.45c-.59,.02-1.61,.14-3.02,.95-1.42,.81-2.09,1.94-2.08,2.81,0,1.06,.8,1.06,2.68,.79,2.55-.39,3.74,.46,3.75,2.78,0,2.78-1.83,6.21-5.79,8.5-1.65,.96-3.28,1.39-4.1,1.35l.67-3.49c.87,.02,2.21-.25,3.61-1.05,1.5-.87,2.3-2.03,2.3-3.12,0-1.03-.69-1.22-2.44-.95-2.38,.43-3.96-.19-3.96-2.6,0-2.82,2.03-6.16,5.44-8.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "578.95 293.93 579.05 331.93 527.32 361.8 527.21 323.81 578.95 293.93"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M552.69,318.02l.03,11.85c.03,6.51-2.83,11.28-7.64,14.05-4.62,2.67-7.36,1.3-7.38-5.44l-.03-11.79,4.15-2.4,.04,12.17c.02,3.64,1.22,4.81,3.36,3.57,2.19-1.26,3.37-3.71,3.36-7.45l-.03-12.17,4.15-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M571.06,307.41l-5.15,13.32,5.48,7.68-4.79,2.77-1.67-2.88c-.7-1.08-1.13-1.91-1.65-2.84l-.07,.04c-.39,1.45-.82,2.79-1.4,4.6l-1.51,4.72-4.76,2.74,5.3-13.77-5.17-7.48,4.79-2.77,1.6,2.94c.56,.97,.97,1.77,1.4,2.72l.07-.03c.42-1.62,.79-2.77,1.22-4.26l1.56-4.75,4.75-2.74Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M415.83,688.62c-22.16,12.81-22.25,33.55-.24,46.34,21.99,12.77,57.83,12.79,79.97,0,22.15-12.79,22.24-33.54,.25-46.33-22.02-12.78-57.81-12.78-79.98-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M437.49,500.08l-2.38,.17c1.02-.6,1.81-1.5,2.41-2.59l2.38-.17c-.58,1.1-1.4,2.01-2.41,2.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M439.91,497.49l-2.38,.17c.4-.77,.7-1.63,.86-2.55l2.37-.15c-.17,.9-.47,1.77-.85,2.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M440.76,494.96l-2.37,.15c.13-.77,.2-1.55,.13-2.34l2.35-.15c.06,.79,.02,1.57-.11,2.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M440.87,492.61l-2.35,.15c-.08-.91-.27-1.82-.59-2.7l2.36-.16c.33,.87,.54,1.8,.58,2.71h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "440.29 489.9 437.92 490.07 432.91 476.87 435.28 476.69 440.29 489.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M435.28,476.69l-2.36,.18c-1.15-3.01-3.56-4.72-5.99-4.55l2.37-.15c2.42-.17,4.84,1.53,5.98,4.52h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M428.77,467.82l-2.36,.16c.23-.12,.43-.23,.66-.31l2.36-.18c-.2,.12-.43,.2-.66,.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M429.42,467.5l-2.36,.18c.5-.2,.98-.32,1.47-.34l2.37-.16c-.5,.03-.98,.15-1.48,.33h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M427.14,472.82l-2.37,.15c.21-.09,.42-.23,.66-.29l2.37-.17c-.24,.09-.45,.2-.66,.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M427.8,472.51l-2.37,.17c.48-.21,.99-.33,1.5-.36l2.37-.15c-.53,.03-1.02,.14-1.5,.34h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "414.91 513.13 412.52 513.28 435.11 500.25 437.49 500.08 414.91 513.13"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M412.75,513.79l-2.37,.15c.49-.02,.99-.13,1.48-.33l2.38-.16c-.5,.2-1.01,.31-1.49,.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M414.24,513.45l-2.38,.16c.24-.08,.45-.2,.67-.32l2.39-.16c-.25,.12-.45,.23-.68,.32h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M412.75,513.79l-2.37,.15c-2.44,.17-4.84-1.54-6-4.52l2.39-.15c1.12,2.97,3.53,4.7,5.98,4.52h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "404.53 485.88 402.17 486.03 424.77 472.97 427.14 472.82 404.53 485.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "406.77 509.27 404.37 509.41 399.35 496.21 401.76 496.06 406.77 509.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M427.14,472.82c3.01-1.73,6.67-.03,8.14,3.87l5.01,13.21c1.47,3.85,.23,8.45-2.79,10.18l-22.58,13.04c-3.06,1.75-6.68,0-8.15-3.86l-5.01-13.21c-1.49-3.89-.24-8.44,2.77-10.18l22.61-13.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M401.76,496.06l-2.4,.16c-.33-.88-.51-1.81-.58-2.75l2.37-.15c.06,.92,.24,1.85,.61,2.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M401.15,493.32l-2.37,.15c-.07-.78-.02-1.57,.12-2.33l2.37-.17c-.14,.76-.2,1.55-.12,2.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M401.27,490.97l-2.37,.17c.17-.89,.44-1.74,.84-2.5l2.38-.14c-.4,.74-.72,1.6-.85,2.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M402.12,488.49l-2.38,.14c.59-1.09,1.41-2,2.43-2.61l2.36-.15c-1.02,.58-1.83,1.5-2.41,2.61h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M428.77,467.82c3.03-1.73,6.68,0,8.16,3.91l7.52,19.79c1.47,3.89,.2,8.44-2.79,10.17l-28.24,16.3c-3.02,1.75-6.65,.04-8.14-3.85l-7.52-19.8c-1.49-3.87-.24-8.46,2.78-10.21l28.23-16.3Zm11.52,22.08l-5.01-13.21c-1.47-3.9-5.13-5.6-8.14-3.87l-22.61,13.05c-3.01,1.74-4.26,6.28-2.77,10.18l5.01,13.21c1.47,3.85,5.09,5.61,8.15,3.86l22.58-13.04c3.02-1.73,4.26-6.33,2.79-10.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M405.28,514.14l-7.52-19.8c-.31-.84-.5-1.72-.58-2.6-.01-.07-.03-.17-.03-.23-.02-.7,0-1.39,.13-2.05,.02-.14,.05-.27,.06-.42,.16-.77,.4-1.51,.77-2.19,.04-.12,.14-.25,.21-.38,.22-.34,.44-.69,.69-.99,.1-.12,.22-.24,.31-.36,.37-.38,.79-.74,1.24-1l28.23-16.3-2.36,.16-28.24,16.31c-.45,.26-.84,.61-1.24,.99-.1,.13-.2,.25-.3,.36-.26,.31-.48,.65-.71,.99-.04,.1-.12,.17-.17,.25-.02,.04-.02,.09-.04,.13-.34,.68-.6,1.42-.73,2.21-.01,.07-.05,.11-.06,.18,0,.07,0,.14,0,.21-.12,.67-.16,1.36-.13,2.04,0,.04-.02,.06,0,.09,0,.07,.03,.11,.03,.17,.1,.88,.24,1.76,.58,2.59l7.5,19.79c1.15,2.99,3.57,4.7,5.98,4.54l2.36-.16c-2.43,.16-4.82-1.54-5.96-4.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M482.8,570.66s-6.16,9.75-12.37,8.55c-6.22-1.2-7.08-2.54-4.43-4.22,2.62-1.68,9.58-6.44,8.26-6.86-1.31-.46-4.24,.19-3.91-1.06,.28-1.29,9.07-2.96,9.07-2.96l6.12,2.96-2.73,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M486.67,697.42c-.37,.08-19.82-.56-15.48,6.71,2.79,4.71,6.71,5.54,9.62,5.63,2.9,.09,8.22-1.6,9.53-.76,1.35,.85,7.92,5.41,11.68,.81,.78-.91,1.28-3.59,.78-5.32-.5-1.72-13.98-7.48-16.13-7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,702.9c2.69,3.36,6.58,3.89,9.49,3.89,2.9,0,8.24-1.33,9.53-.75,1.33,.59,7.8,3.77,11.64,.35,.45-.37,.8-1.11,.92-1.9-2.66,2.88-9.09,2.24-10.87,1.33-2.04-1.01-4.96-1.47-7.48-1.05-2.56,.43-8.08,.09-10.78-1.81-1.65-1.13-1.52-2.5-1.18-3.38-1.74,.75-2.49,1.81-1.28,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M489.1,535.53s23.51,30.43,11.69,65.79c-2.59,7.69-7.72,24.08-6.02,32.13,2.08,9.68,5.09,6.94,7.28,38.97,1.95,28.3,1.6,22.15,2.25,33.61,.19,3.28-11.69,6.68-13.49,1.61-7.84-22.15-18.75-68.62-16.57-94.22,2.17-25.61,3.58-49.55,3.58-49.55,0,0,3.57-21.06,11.28-28.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.92,710.49c-.37,0-20.48-4.47-17.2,3.92,2.14,5.43,6.01,7.07,9.04,7.71,2.98,.66,8.8-.06,10.02,1.07,1.23,1.15,7.31,7.17,11.96,3.14,.97-.81,1.96-3.5,1.74-5.37-.25-1.86-13.24-10.48-15.56-10.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72,714.41c2.14,5.43,6.01,7.07,9.04,7.71,2.98,.66,8.8-.06,10.02,1.07,1.23,1.15,7.31,7.17,11.96,3.14,.56-.43,1.07-1.42,1.39-2.52-3.37,3.49-9.93,1.15-11.57-.55-1.88-1.88-4.8-3.24-7.54-3.18-2.74,.05-8.34-1.68-10.77-5.01-1.47-2-1.07-3.93-.5-5.11-1.96,.67-2.99,2.02-2.04,4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M490.77,564.49s13.32,14.18-10.54,50.07c0,0-11.62,25.54-11.18,33.71,.47,9.78,4.42,10.68,.54,42.67-3.34,27.77-1.93,28.34-4.09,30.68-2.26,2.45-13.59,.07-13.98-4.87-2.12-27.16-6.37-67.1-3.92-92.38,2.83-29.03,4.89-52.89,4.89-52.89,0,0,29.51-1.33,38.28-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M447.6,624.37c-2.45,25.28,1.8,65.22,3.92,92.38,.16,1.94,1.98,3.46,4.28,4.49-.27-9.4-1.7-64.77-1.78-77.69-.14-14.14-1.64-40.52,7.77-48.24,9.4-7.71,13.61-21.62,13.61-21.62l-1.59-4.33c-10.5,1.65-21.32,2.13-21.32,2.13,0,0-2.06,23.86-4.89,52.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M486.87,501.38s-1.18-11,9.42-11.19c11.26-.22,8.73,23.24,8.73,23.24,0,0-.56,20.28-2.56,26.57-2.69,8.36-17.58,30.03-17.58,30.03,0,0-6.62-1.56-8.56-6.28,0,0,11.75-20.45,12.78-28.23,1.13-8.45-2.5-32.29-2.24-34.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M484.88,570.04s14.89-21.67,17.58-30.03c2-6.29,2.56-26.57,2.56-26.57,0,0,4.02-22.61-8.67-23.65-5.16-.42-6.02,1.76-7.25,3.44,8.18,.48,8.98,5.94,8.22,18.11-.83,13.19,.9,16.94,.15,28.22-.74,11.26-12.66,22.25-14.48,24.91-1.19,1.75-4.07-.39-5.93-2.05-.46,.86-.74,1.35-.74,1.35,1.94,4.72,8.56,6.28,8.56,6.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M469.36,481.2s2.87,8.6-1.28,14.27c-2.25,3.09,19.93,7.89,17.76-1.15-1.76-7.44,1.24-14.2,6.73-19.87l-23.2,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M470.34,487.45s5.44-1.24,8.61-3.12l.36,.2,2.08,.52,.77,.3s-1.14,9.26-12.97,8.2c0,0,1-2.49,1.15-6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M469.14,445.82s-3.6,5.86-8.45,15.77c-4.28,8.74-5.02,18.83,.55,23.42,2.61,2.15,21.1,6.47,29.41-14.99,5.31-13.67-3.97-31.66-21.51-24.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M459.47,449.15c-2.24,1.95-.6,4.94,5.1,7.43,8.14,3.54,1.88,14.3,4.62,16.42,1.54,1.2,2.45,2.07,6.49-.85,1.61-1.14,4.16-2.23,4.56,2.36,.34,4.33-2.58,3.58-3.92,9.82-.55,2.48,6.79,3.36,9.51,1.55,8.15-5.38,19.04-21.24,8.04-36.84-8.34-11.83-30.58-3.24-34.39,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M504.91,571.06c-.07-1.92-.52-4.18-1.1-6.95-.03-.12-.03-.22-.06-.32-1.47-7.42-3.16-11.59-3.16-11.59h-.11c-2.94-8.07-5.51-11.32-4.22-21.61,.65-5.25,5.41-20.91,4.78-32.49-.59-11.59-13.14-11.44-33.3-3.28-20.16,8.14-17.18,20.46-17.18,20.46,2.5,12.42,7.34,14.42,3.35,45.52q-.4,1.61-2.2,14.24c-3.1,21.59,50.05,11.11,53.17-3.97h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M404.86,516.34s-2.16-.46-5.21-3.32c-3.01-2.89-2.6-2.77-3.48-5.27-.93-2.5,0-5.9,.95-6.73,1.24-1.09,2.56-.13,4.84,4.78,2.35,5.06,7.55,4.78,8.31,5.68,.75,.91-4.13,5.36-5.42,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M404.68,511.44c-.64-.24,.29-2.61-2.41-7.55-2.08-3.83,2.45,.02,3.01,.92,.54,.89,5.04,6.87,5.04,6.87,0,0-3.37,.6-5.64-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M467.66,511.66c.21-2.43-1.35-9.98-8.57-10.64-4.71-.43-26.86,24.43-30.2,24.49-1.62,.07-18.98-16.17-18.98-16.17,0,0,.84,4.84-6.27,7.59,0,0,18.19,25.68,25.4,23.52,12.37-3.7,37.72-17.35,38.61-28.79Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "560.76 393.54 551.05 387.9 555.44 385.36 565.16 391 560.76 393.54"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M518.78,454.86l-9.71-5.65c-1.75-1.02-2.84-3.18-2.87-6.24l9.72,5.64c0,3.07,1.11,5.24,2.86,6.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M518.78,454.86l-9.71-5.65c-1.75-1.02-2.84-3.18-2.87-6.24l9.72,5.64c0,3.07,1.11,5.24,2.86,6.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M573.87,370.84c-.03-6.22-4.43-8.69-9.8-5.59l-38.53,22.24c-5.38,3.11-9.76,10.66-9.74,16.87v3.88s-1.58,.91-1.58,.91l1.59,2.32,.03,10.48-1.7,4.47,1.72,1,.06,21.17c.02,6.22,4.43,8.68,9.8,5.59l38.54-22.26c5.36-3.1,9.76-10.64,9.71-16.86l-.11-44.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M561.3,358.94l9.72,5.64c-1.78-1.03-4.23-.88-6.94,.68l-9.73-5.64c2.71-1.56,5.18-1.71,6.96-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M564.07,365.26l-9.73-5.64c.48-.27,.92-.5,1.37-.67l9.71,5.64c-.44,.19-.89,.41-1.36,.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M565.43,364.58l-9.71-5.64c.39-.17,.78-.3,1.15-.4l9.72,5.64c-.38,.11-.77,.24-1.15,.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M566.59,364.19l-9.72-5.64c.3-.08,.58-.14,.87-.19l9.7,5.66c-.28,.04-.56,.09-.85,.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M567.44,364.01l-9.7-5.66c.23-.03,.48-.05,.73-.07l9.7,5.64c-.23,0-.47,.03-.73,.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M568.17,363.93l-9.7-5.64c.21,0,.43,0,.65,0l9.7,5.65c-.22-.02-.43-.02-.65,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M568.81,363.93l-9.7-5.65c.2,.01,.39,.04,.6,.07l9.7,5.66c-.2-.04-.39-.07-.6-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M569.41,364.01l-9.7-5.66c.16,.04,.35,.07,.53,.14l9.71,5.63c-.17-.04-.36-.09-.54-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M569.95,364.12l-9.71-5.63c.17,.05,.35,.12,.51,.17l9.71,5.65c-.17-.07-.32-.13-.51-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M570.47,364.32l-9.71-5.65c.16,.07,.34,.17,.49,.25l9.71,5.64c-.16-.09-.32-.17-.5-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M570.97,364.55l-9.71-5.64s.04,.03,.05,.03l9.72,5.64s-.03-.02-.05-.03h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "515.92 448.59 506.2 442.96 506.09 398.72 515.81 404.36 515.92 448.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "525.55 387.5 515.82 381.86 554.35 359.61 564.07 365.26 525.55 387.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M515.81,404.36l-9.72-5.64c-.01-6.23,4.37-13.77,9.73-16.86l9.73,5.64c-5.38,3.11-9.76,10.66-9.74,16.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M515.81,404.36l-9.72-5.64c0-.63,.05-1.26,.12-1.92l9.72,5.64c-.08,.65-.12,1.29-.11,1.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M515.92,402.45l-9.72-5.64c.07-.44,.15-.89,.25-1.35l9.72,5.64c-.1,.45-.2,.91-.25,1.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M516.17,401.1l-9.72-5.64c.08-.37,.17-.73,.28-1.11l9.69,5.63c-.09,.38-.19,.76-.25,1.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M516.42,399.97l-9.69-5.63c.08-.32,.18-.67,.3-1l9.71,5.65c-.11,.33-.22,.66-.32,.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M516.74,398.99l-9.71-5.65c.1-.28,.21-.62,.34-.92l9.7,5.64c-.13,.31-.23,.62-.33,.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M517.07,398.06l-9.7-5.64c.09-.3,.21-.59,.34-.88l9.71,5.64c-.13,.3-.24,.59-.36,.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M517.43,397.19l-9.71-5.64c.13-.28,.25-.55,.38-.84l9.73,5.64c-.16,.29-.27,.56-.4,.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M517.82,396.35l-9.73-5.64c.15-.28,.27-.56,.43-.84l9.71,5.65c-.14,.27-.27,.54-.41,.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M518.23,395.52l-9.71-5.65c.15-.27,.3-.54,.45-.82l9.72,5.64c-.17,.26-.32,.54-.47,.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M518.7,394.69l-9.72-5.64c.17-.28,.35-.55,.51-.83l9.71,5.63c-.19,.29-.35,.57-.51,.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M519.21,393.85l-9.71-5.63c.18-.29,.36-.56,.56-.85l9.73,5.65c-.22,.27-.39,.56-.57,.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M519.78,393.02l-9.73-5.65c.21-.29,.43-.59,.65-.87l9.7,5.64c-.22,.27-.43,.57-.63,.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M520.41,392.14l-9.7-5.64c.26-.35,.52-.68,.78-.98l9.73,5.65c-.29,.32-.54,.64-.81,.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M521.22,391.17l-9.73-5.65c.36-.39,.71-.77,1.07-1.14l9.72,5.64c-.37,.37-.72,.74-1.07,1.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M522.28,390.02l-9.72-5.64c1.03-1.01,2.13-1.87,3.26-2.53l9.73,5.64c-1.15,.66-2.25,1.53-3.27,2.52h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M543.46,398.81l6.14,18.94-4.77,2.74-1.52-4.91-5.59,3.23-1.38,6.56-4.57,2.65,5.92-25.88,5.77-3.34Zm-5.11,15.85l4.32-2.5-1.23-4.05c-.34-1.11-.7-2.59-1-3.74l-.05,.03c-.3,1.49-.57,3.36-.91,4.84l-1.13,5.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M553.98,396.87c-1.38,.81-2.29,.21-2.27-1.19-.03-1.47,.87-3.09,2.32-3.92,1.42-.82,2.31-.23,2.35,1.21,.01,1.41-.92,3.06-2.4,3.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "551.87 416.43 551.83 400.14 556.24 397.59 556.28 413.87 551.87 416.43"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevWhite);
export default __webpack_public_path__ + "static/media/SoftwareDevWhite.8568442e4ec76396ab3a1ee2da854da8.svg";
export { ForwardRef as ReactComponent };